/* tslint:disable */
/* eslint-disable */
/**
 * Mr.Bilit Hotel service api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
    DUMMY_BASE_URL,
    assertParamExists,
    setApiKeyToObject,
    setBasicAuthToObject,
    setBearerAuthToObject,
    setOAuthToObject,
    setSearchParams,
    serializeDataIfNeeded,
    toPathString,
    createRequestFunction,
} from '../common';
// @ts-ignore
import {
    BASE_PATH,
    COLLECTION_FORMATS,
    RequestArgs,
    RequiredError,
} from '../base';
// @ts-ignore
import { AddAmenityRequest } from '../model';
// @ts-ignore
import { AddHotelAmenitiesRequest } from '../model';
// @ts-ignore
import { AddHotelBlockRequest } from '../model';
// @ts-ignore
import { AddHotelMappingRequest } from '../model';
// @ts-ignore
import { AddHotelMarkupRequest } from '../model';
// @ts-ignore
import { AddHotelPopularPlaceRequest } from '../model';
// @ts-ignore
import { AddHotelRoomTypeRequest } from '../model';
// @ts-ignore
import { AddHotelSpecialOfferRequest } from '../model';
// @ts-ignore
import { AmenityListResponse } from '../model';
// @ts-ignore
import { AutoCompleteHotelResponse } from '../model';
// @ts-ignore
import { CityListResponse } from '../model';
// @ts-ignore
import { CreateHotelCommentRequest } from '../model';
// @ts-ignore
import { CreateHotelRequest } from '../model';
// @ts-ignore
import { CreateHotelResponse } from '../model';
// @ts-ignore
import { CreateHotelTagRequest } from '../model';
// @ts-ignore
import { DNTCaptchaApiResponse } from '../model';
// @ts-ignore
import { EditHotelMessageRequest } from '../model';
// @ts-ignore
import { GetHotelAmenitiesResponse } from '../model';
// @ts-ignore
import { GetHotelBlockDetailsResponse } from '../model';
// @ts-ignore
import { GetHotelBlockListResponse } from '../model';
// @ts-ignore
import { GetHotelCommentDetailResponse } from '../model';
// @ts-ignore
import { GetHotelCommentListResponse } from '../model';
// @ts-ignore
import { GetHotelMappingListResponse } from '../model';
// @ts-ignore
import { GetHotelMarkupDetailDto } from '../model';
// @ts-ignore
import { GetHotelMarkupResponse } from '../model';
// @ts-ignore
import { GetHotelPopularPlaceResponse } from '../model';
// @ts-ignore
import { GetHotelSpecialOffersResponse } from '../model';
// @ts-ignore
import { GetVisibleHotelBlockResponse } from '../model';
// @ts-ignore
import { HotelBlockResponse } from '../model';
// @ts-ignore
import { HotelCityFullDetailView } from '../model';
// @ts-ignore
import { HotelCityNameDto } from '../model';
// @ts-ignore
import { HotelDto } from '../model';
// @ts-ignore
import { HotelFullDetailView } from '../model';
// @ts-ignore
import { HotelFullDetailsResponse } from '../model';
// @ts-ignore
import { HotelNearByCitiesResponse } from '../model';
// @ts-ignore
import { HotelResponse } from '../model';
// @ts-ignore
import { HotelRoomTypeView } from '../model';
// @ts-ignore
import { HotelSearchResponse } from '../model';
// @ts-ignore
import { HotelShortDetailResponse } from '../model';
// @ts-ignore
import { HotelTypeListResponse } from '../model';
// @ts-ignore
import { OphanHotelMappingsResponse } from '../model';
// @ts-ignore
import { RoomsResponse } from '../model';
// @ts-ignore
import { SortHotelMarkupRequest } from '../model';
// @ts-ignore
import { UpdateAmenityRequest } from '../model';
// @ts-ignore
import { UpdateCommentRatingFactor } from '../model';
// @ts-ignore
import { UpdateHotelBlockRequest } from '../model';
// @ts-ignore
import { UpdateHotelCommentRequest } from '../model';
// @ts-ignore
import { UpdateHotelImageRequest } from '../model';
// @ts-ignore
import { UpdateHotelMappingRequest } from '../model';
// @ts-ignore
import { UpdateHotelMarkupDto } from '../model';
// @ts-ignore
import { UpdateHotelRequest } from '../model';
// @ts-ignore
import { UpdateHotelRoomTypeMappingRequest } from '../model';
// @ts-ignore
import { UpdateHotelRoomTypeRequest } from '../model';
// @ts-ignore
import { UpdateHotelSpecialOfferRequest } from '../model';
/**
 * HotelApiApiHotelAddAmenityPost - axios parameter creator
 *
 * @param {AddAmenityRequest} [addAmenityRequest]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelAddAmenityPostAxiosParamCreator(
    addAmenityRequest?: AddAmenityRequest,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/AddAmenity`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
        addAmenityRequest,
        localVarRequestOptions,
        configuration
    );

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelAddHotelBlockPost - axios parameter creator
 *
 * @summary Add Hotel Block with details
 * @param {AddHotelBlockRequest} [addHotelBlockRequest]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelAddHotelBlockPostAxiosParamCreator(
    addHotelBlockRequest?: AddHotelBlockRequest,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/AddHotelBlock`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
        addHotelBlockRequest,
        localVarRequestOptions,
        configuration
    );

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelAddHotelMarkupPost - axios parameter creator
 *
 * @summary Add Hotel Markup with its constraints
 * @param {AddHotelMarkupRequest} [addHotelMarkupRequest]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelAddHotelMarkupPostAxiosParamCreator(
    addHotelMarkupRequest?: AddHotelMarkupRequest,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/AddHotelMarkup`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
        addHotelMarkupRequest,
        localVarRequestOptions,
        configuration
    );

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelAddSpecialOfferPost - axios parameter creator
 *
 * @summary Add Special Offer with its items
 * @param {AddHotelSpecialOfferRequest} [addHotelSpecialOfferRequest]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelAddSpecialOfferPostAxiosParamCreator(
    addHotelSpecialOfferRequest?: AddHotelSpecialOfferRequest,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/AddSpecialOffer`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
        addHotelSpecialOfferRequest,
        localVarRequestOptions,
        configuration
    );

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelAmenitiesGet - axios parameter creator
 *
 * @summary Get Amenity List
 * @param {string} [searchTerm]
 * @param {boolean} [isForHotel]
 * @param {boolean} [isForRoom]
 * @param {number} [pageIndex]
 * @param {number} [pageSize]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelAmenitiesGetAxiosParamCreator(
    searchTerm?: string,
    isForHotel?: boolean,
    isForRoom?: boolean,
    pageIndex?: number,
    pageSize?: number,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/Amenities`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    if (searchTerm !== undefined) {
        localVarQueryParameter['searchTerm'] = searchTerm;
    }

    if (isForHotel !== undefined) {
        localVarQueryParameter['isForHotel'] = isForHotel;
    }

    if (isForRoom !== undefined) {
        localVarQueryParameter['isForRoom'] = isForRoom;
    }

    if (pageIndex !== undefined) {
        localVarQueryParameter['pageIndex'] = pageIndex;
    }

    if (pageSize !== undefined) {
        localVarQueryParameter['pageSize'] = pageSize;
    }

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelAmenityIdRemoveAmenityDelete - axios parameter creator
 *
 * @param {number} amenityId
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelAmenityIdRemoveAmenityDeleteAxiosParamCreator(
    amenityId: number,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'amenityId' is not null or undefined
    assertParamExists(
        'apiHotelAmenityIdRemoveAmenityDelete',
        'amenityId',
        amenityId
    );
    const localVarPath = `/api/hotel/{amenityId}/RemoveAmenity`.replace(
        `{${'amenityId'}}`,
        encodeURIComponent(String(amenityId))
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelBackgroundHotelUpdatePost - axios parameter creator
 *
 * @param {number} [hotelId]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelBackgroundHotelUpdatePostAxiosParamCreator(
    hotelId?: number,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/BackgroundHotelUpdate`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    if (hotelId !== undefined) {
        localVarQueryParameter['hotelId'] = hotelId;
    }

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelChangeActivationHotelMarkupPut - axios parameter creator
 *
 * @summary Active and deActive markups with their Ids
 * @param {number} [markupId]
 * @param {boolean} [isActive]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelChangeActivationHotelMarkupPutAxiosParamCreator(
    markupId?: number,
    isActive?: boolean,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/ChangeActivationHotelMarkup`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    if (markupId !== undefined) {
        localVarQueryParameter['markupId'] = markupId;
    }

    if (isActive !== undefined) {
        localVarQueryParameter['isActive'] = isActive;
    }

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelCityListGet - axios parameter creator
 *
 * @summary Get City List (Id and PersianName)
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelCityListGetAxiosParamCreator(
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/CityList`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelCityNameGetAllHotelRoomGet - axios parameter creator
 *
 * @param {string} cityName
 * @param {string} [hotelName]
 * @param {number} [pageIndex]
 * @param {number} [pageSize]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelCityNameGetAllHotelRoomGetAxiosParamCreator(
    cityName: string,
    hotelName?: string,
    pageIndex?: number,
    pageSize?: number,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'cityName' is not null or undefined
    assertParamExists(
        'apiHotelCityNameGetAllHotelRoomGet',
        'cityName',
        cityName
    );
    const localVarPath = `/api/hotel/{cityName}/GetAllHotelRoom`.replace(
        `{${'cityName'}}`,
        encodeURIComponent(String(cityName))
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    if (hotelName !== undefined) {
        localVarQueryParameter['hotelName'] = hotelName;
    }

    if (pageIndex !== undefined) {
        localVarQueryParameter['pageIndex'] = pageIndex;
    }

    if (pageSize !== undefined) {
        localVarQueryParameter['pageSize'] = pageSize;
    }

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelCityNameHotelNameGet - axios parameter creator
 *
 * @param {string} cityName
 * @param {string} hotelName
 * @param {string} [from]
 * @param {string} [to]
 * @param {number} [adultCount]
 * @param {number} [childrenCount]
 * @param {number} [roomCount]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelCityNameHotelNameGetAxiosParamCreator(
    cityName: string,
    hotelName: string,
    from?: string,
    to?: string,
    adultCount?: number,
    childrenCount?: number,
    roomCount?: number,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'cityName' is not null or undefined
    assertParamExists('apiHotelCityNameHotelNameGet', 'cityName', cityName);
    // verify required parameter 'hotelName' is not null or undefined
    assertParamExists('apiHotelCityNameHotelNameGet', 'hotelName', hotelName);
    const localVarPath = `/api/hotel/{cityName}/{hotelName}`
        .replace(`{${'cityName'}}`, encodeURIComponent(String(cityName)))
        .replace(`{${'hotelName'}}`, encodeURIComponent(String(hotelName)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    if (from !== undefined) {
        localVarQueryParameter['from'] =
            (from as any) instanceof Date ? (from as any).toISOString() : from;
    }

    if (to !== undefined) {
        localVarQueryParameter['to'] =
            (to as any) instanceof Date ? (to as any).toISOString() : to;
    }

    if (adultCount !== undefined) {
        localVarQueryParameter['adultCount'] = adultCount;
    }

    if (childrenCount !== undefined) {
        localVarQueryParameter['childrenCount'] = childrenCount;
    }

    if (roomCount !== undefined) {
        localVarQueryParameter['roomCount'] = roomCount;
    }

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelCityNameHotelNameRoomsGet - axios parameter creator
 *
 * @param {string} cityName
 * @param {string} hotelName
 * @param {string} [from]
 * @param {string} [to]
 * @param {number} [adultCount]
 * @param {number} [childrenCount]
 * @param {number} [roomCount]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelCityNameHotelNameRoomsGetAxiosParamCreator(
    cityName: string,
    hotelName: string,
    from?: string,
    to?: string,
    adultCount?: number,
    childrenCount?: number,
    roomCount?: number,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'cityName' is not null or undefined
    assertParamExists(
        'apiHotelCityNameHotelNameRoomsGet',
        'cityName',
        cityName
    );
    // verify required parameter 'hotelName' is not null or undefined
    assertParamExists(
        'apiHotelCityNameHotelNameRoomsGet',
        'hotelName',
        hotelName
    );
    const localVarPath = `/api/hotel/{cityName}/{hotelName}/rooms`
        .replace(`{${'cityName'}}`, encodeURIComponent(String(cityName)))
        .replace(`{${'hotelName'}}`, encodeURIComponent(String(hotelName)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    if (from !== undefined) {
        localVarQueryParameter['from'] =
            (from as any) instanceof Date ? (from as any).toISOString() : from;
    }

    if (to !== undefined) {
        localVarQueryParameter['to'] =
            (to as any) instanceof Date ? (to as any).toISOString() : to;
    }

    if (adultCount !== undefined) {
        localVarQueryParameter['adultCount'] = adultCount;
    }

    if (childrenCount !== undefined) {
        localVarQueryParameter['childrenCount'] = childrenCount;
    }

    if (roomCount !== undefined) {
        localVarQueryParameter['roomCount'] = roomCount;
    }

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelCityNameHotelNameStaticGet - axios parameter creator
 *
 * @param {string} cityName
 * @param {string} hotelName
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelCityNameHotelNameStaticGetAxiosParamCreator(
    cityName: string,
    hotelName: string,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'cityName' is not null or undefined
    assertParamExists(
        'apiHotelCityNameHotelNameStaticGet',
        'cityName',
        cityName
    );
    // verify required parameter 'hotelName' is not null or undefined
    assertParamExists(
        'apiHotelCityNameHotelNameStaticGet',
        'hotelName',
        hotelName
    );
    const localVarPath = `/api/hotel/{cityName}/{hotelName}/static`
        .replace(`{${'cityName'}}`, encodeURIComponent(String(cityName)))
        .replace(`{${'hotelName'}}`, encodeURIComponent(String(hotelName)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelCityNameListGet - axios parameter creator
 *
 * @summary Get City List (only PersianName)
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelCityNameListGetAxiosParamCreator(
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/CityNameList`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelCityTagGet - axios parameter creator
 *
 * @param {string} cityTag
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelCityTagGetAxiosParamCreator(
    cityTag: string,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'cityTag' is not null or undefined
    assertParamExists('apiHotelCityTagGet', 'cityTag', cityTag);
    const localVarPath = `/api/hotel/{cityTag}`.replace(
        `{${'cityTag'}}`,
        encodeURIComponent(String(cityTag))
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelCommentCaptchaGet - axios parameter creator
 *
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelCommentCaptchaGetAxiosParamCreator(
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/CommentCaptcha`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelCreateHotelMappingHotelIdPost - axios parameter creator
 *
 * @param {number} hotelId
 * @param {AddHotelMappingRequest} [addHotelMappingRequest]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelCreateHotelMappingHotelIdPostAxiosParamCreator(
    hotelId: number,
    addHotelMappingRequest?: AddHotelMappingRequest,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'hotelId' is not null or undefined
    assertParamExists(
        'apiHotelCreateHotelMappingHotelIdPost',
        'hotelId',
        hotelId
    );
    const localVarPath = `/api/hotel/CreateHotelMapping/{hotelId}`.replace(
        `{${'hotelId'}}`,
        encodeURIComponent(String(hotelId))
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
        addHotelMappingRequest,
        localVarRequestOptions,
        configuration
    );

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelDeleteHotelBlockDelete - axios parameter creator
 *
 * @summary Delete Hotel Block with its Details
 * @param {number} [blockId]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelDeleteHotelBlockDeleteAxiosParamCreator(
    blockId?: number,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/DeleteHotelBlock`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    if (blockId !== undefined) {
        localVarQueryParameter['blockId'] = blockId;
    }

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelDeleteHotelMappingHotelIdHotelMappingIdDelete - axios parameter creator
 *
 * @param {number} hotelId
 * @param {number} hotelMappingId
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelDeleteHotelMappingHotelIdHotelMappingIdDeleteAxiosParamCreator(
    hotelId: number,
    hotelMappingId: number,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'hotelId' is not null or undefined
    assertParamExists(
        'apiHotelDeleteHotelMappingHotelIdHotelMappingIdDelete',
        'hotelId',
        hotelId
    );
    // verify required parameter 'hotelMappingId' is not null or undefined
    assertParamExists(
        'apiHotelDeleteHotelMappingHotelIdHotelMappingIdDelete',
        'hotelMappingId',
        hotelMappingId
    );
    const localVarPath =
        `/api/hotel/DeleteHotelMapping/{hotelId}/{hotelMappingId}`
            .replace(`{${'hotelId'}}`, encodeURIComponent(String(hotelId)))
            .replace(
                `{${'hotelMappingId'}}`,
                encodeURIComponent(String(hotelMappingId))
            );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelDeleteHotelMarkupDelete - axios parameter creator
 *
 * @summary Delete Hotel Markup with its constraints
 * @param {number} [markupId]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelDeleteHotelMarkupDeleteAxiosParamCreator(
    markupId?: number,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/DeleteHotelMarkup`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    if (markupId !== undefined) {
        localVarQueryParameter['markupId'] = markupId;
    }

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelDeleteSpecialOfferDelete - axios parameter creator
 *
 * @summary Delete Special Offer with its items
 * @param {number} [specialOfferId]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelDeleteSpecialOfferDeleteAxiosParamCreator(
    specialOfferId?: number,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/DeleteSpecialOffer`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    if (specialOfferId !== undefined) {
        localVarQueryParameter['specialOfferId'] = specialOfferId;
    }

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelGetAllHotelsGet - axios parameter creator
 *
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelGetAllHotelsGetAxiosParamCreator(
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/GetAllHotels`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelGetHotelsWithRoomsCityIdGet - axios parameter creator
 *
 * @param {number} cityId
 * @param {string} [from]
 * @param {string} [to]
 * @param {boolean} [isOnlyDb]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelGetHotelsWithRoomsCityIdGetAxiosParamCreator(
    cityId: number,
    from?: string,
    to?: string,
    isOnlyDb?: boolean,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'cityId' is not null or undefined
    assertParamExists('apiHotelGetHotelsWithRoomsCityIdGet', 'cityId', cityId);
    const localVarPath = `/api/hotel/GetHotelsWithRooms/{cityId}`.replace(
        `{${'cityId'}}`,
        encodeURIComponent(String(cityId))
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    if (from !== undefined) {
        localVarQueryParameter['from'] =
            (from as any) instanceof Date ? (from as any).toISOString() : from;
    }

    if (to !== undefined) {
        localVarQueryParameter['to'] =
            (to as any) instanceof Date ? (to as any).toISOString() : to;
    }

    if (isOnlyDb !== undefined) {
        localVarQueryParameter['isOnlyDb'] = isOnlyDb;
    }

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelAutoCompleteListGet - axios parameter creator
 *
 * @summary Get Hotel AutoComplete List
 * @param {string} [searchTerm]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelAutoCompleteListGetAxiosParamCreator(
    searchTerm?: string,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/HotelAutoCompleteList`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    if (searchTerm !== undefined) {
        localVarQueryParameter['searchTerm'] = searchTerm;
    }

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelAvailabilityCityNameHotelNameGet - axios parameter creator
 *
 * @param {string} cityName
 * @param {string} hotelName
 * @param {string} [from]
 * @param {string} [to]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelAvailabilityCityNameHotelNameGetAxiosParamCreator(
    cityName: string,
    hotelName: string,
    from?: string,
    to?: string,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'cityName' is not null or undefined
    assertParamExists(
        'apiHotelHotelAvailabilityCityNameHotelNameGet',
        'cityName',
        cityName
    );
    // verify required parameter 'hotelName' is not null or undefined
    assertParamExists(
        'apiHotelHotelAvailabilityCityNameHotelNameGet',
        'hotelName',
        hotelName
    );
    const localVarPath = `/api/hotel/HotelAvailability/{cityName}/{hotelName}`
        .replace(`{${'cityName'}}`, encodeURIComponent(String(cityName)))
        .replace(`{${'hotelName'}}`, encodeURIComponent(String(hotelName)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    if (from !== undefined) {
        localVarQueryParameter['from'] =
            (from as any) instanceof Date ? (from as any).toISOString() : from;
    }

    if (to !== undefined) {
        localVarQueryParameter['to'] =
            (to as any) instanceof Date ? (to as any).toISOString() : to;
    }

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelBlockDetailGet - axios parameter creator
 *
 * @summary Get Hotel Block Detail
 * @param {string} [cityName]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelBlockDetailGetAxiosParamCreator(
    cityName?: string,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/HotelBlockDetail`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    if (cityName !== undefined) {
        localVarQueryParameter['cityName'] = cityName;
    }

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelBlockListGet - axios parameter creator
 *
 * @summary Get Hotel Block List
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelBlockListGetAxiosParamCreator(
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/HotelBlockList`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelBlocksGet - axios parameter creator
 *
 * @summary Get Hotel Block Detail to preview
 * @param {number} [blockId]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelBlocksGetAxiosParamCreator(
    blockId?: number,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/HotelBlocks`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    if (blockId !== undefined) {
        localVarQueryParameter['blockId'] = blockId;
    }

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelCommentCommentIdDelete - axios parameter creator
 *
 * @param {number} commentId
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelCommentCommentIdDeleteAxiosParamCreator(
    commentId: number,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'commentId' is not null or undefined
    assertParamExists(
        'apiHotelHotelCommentCommentIdDelete',
        'commentId',
        commentId
    );
    const localVarPath = `/api/hotel/HotelComment/{commentId}`.replace(
        `{${'commentId'}}`,
        encodeURIComponent(String(commentId))
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelCommentDetailHotelCommentIdGet - axios parameter creator
 *
 * @param {number} hotelCommentId
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelCommentDetailHotelCommentIdGetAxiosParamCreator(
    hotelCommentId: number,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'hotelCommentId' is not null or undefined
    assertParamExists(
        'apiHotelHotelCommentDetailHotelCommentIdGet',
        'hotelCommentId',
        hotelCommentId
    );
    const localVarPath =
        `/api/hotel/HotelCommentDetail/{hotelCommentId}`.replace(
            `{${'hotelCommentId'}}`,
            encodeURIComponent(String(hotelCommentId))
        );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelCommentListHotelIdGet - axios parameter creator
 *
 * @summary Get Hotel comment List
 * @param {number} hotelId
 * @param {number} [pageIndex]
 * @param {number} [pageSize]
 * @param {boolean} [isActive]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelCommentListHotelIdGetAxiosParamCreator(
    hotelId: number,
    pageIndex?: number,
    pageSize?: number,
    isActive?: boolean,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'hotelId' is not null or undefined
    assertParamExists('apiHotelHotelCommentListHotelIdGet', 'hotelId', hotelId);
    const localVarPath = `/api/hotel/HotelCommentList/{hotelId}`.replace(
        `{${'hotelId'}}`,
        encodeURIComponent(String(hotelId))
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    if (pageIndex !== undefined) {
        localVarQueryParameter['pageIndex'] = pageIndex;
    }

    if (pageSize !== undefined) {
        localVarQueryParameter['pageSize'] = pageSize;
    }

    if (isActive !== undefined) {
        localVarQueryParameter['isActive'] = isActive;
    }

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelCommentPost - axios parameter creator
 *
 * @param {CreateHotelCommentRequest} [createHotelCommentRequest]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelCommentPostAxiosParamCreator(
    createHotelCommentRequest?: CreateHotelCommentRequest,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/HotelComment`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
        createHotelCommentRequest,
        localVarRequestOptions,
        configuration
    );

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelFullDetailsHotelIdGet - axios parameter creator
 *
 * @summary Get Hotel Full Details
 * @param {number} hotelId
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelFullDetailsHotelIdGetAxiosParamCreator(
    hotelId: number,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'hotelId' is not null or undefined
    assertParamExists('apiHotelHotelFullDetailsHotelIdGet', 'hotelId', hotelId);
    const localVarPath = `/api/hotel/HotelFullDetails/{hotelId}`.replace(
        `{${'hotelId'}}`,
        encodeURIComponent(String(hotelId))
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelIdAddCommentPost - axios parameter creator
 *
 * @param {number} hotelId
 * @param {string} [body]
 * @param {boolean} [reserved]
 * @param {Array<UpdateCommentRatingFactor>} [commentRatings]
 * @param {Array<File>} [photos]
 * @param {string} [dNTCaptchaText]
 * @param {string} [dNTCaptchaInputText]
 * @param {string} [dNTCaptchaToken]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelIdAddCommentPostAxiosParamCreator(
    hotelId: number,
    body?: string,
    reserved?: boolean,
    commentRatings?: Array<UpdateCommentRatingFactor>,
    photos?: Array<File>,
    dNTCaptchaText?: string,
    dNTCaptchaInputText?: string,
    dNTCaptchaToken?: string,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'hotelId' is not null or undefined
    assertParamExists('apiHotelHotelIdAddCommentPost', 'hotelId', hotelId);
    const localVarPath = `/api/hotel/{hotelId}/AddComment`.replace(
        `{${'hotelId'}}`,
        encodeURIComponent(String(hotelId))
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;
    const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    if (body !== undefined) {
        localVarFormParams.append('Body', body as any);
    }

    if (reserved !== undefined) {
        localVarFormParams.append('Reserved', reserved as any);
    }
    if (commentRatings) {
        commentRatings.forEach(element => {
            localVarFormParams.append('CommentRatings[]', element as any);
        });
    }

    if (photos) {
        photos.forEach(element => {
            localVarFormParams.append('Photos', element as any);
        });
    }

    if (dNTCaptchaText !== undefined) {
        localVarFormParams.append('DNTCaptchaText', dNTCaptchaText as any);
    }

    if (dNTCaptchaInputText !== undefined) {
        localVarFormParams.append(
            'DNTCaptchaInputText',
            dNTCaptchaInputText as any
        );
    }

    if (dNTCaptchaToken !== undefined) {
        localVarFormParams.append('DNTCaptchaToken', dNTCaptchaToken as any);
    }

    localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };
    localVarRequestOptions.data = localVarFormParams;

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelIdAddHotelRoomTypePost - axios parameter creator
 *
 * @param {number} hotelId
 * @param {AddHotelRoomTypeRequest} [addHotelRoomTypeRequest]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelIdAddHotelRoomTypePostAxiosParamCreator(
    hotelId: number,
    addHotelRoomTypeRequest?: AddHotelRoomTypeRequest,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'hotelId' is not null or undefined
    assertParamExists(
        'apiHotelHotelIdAddHotelRoomTypePost',
        'hotelId',
        hotelId
    );
    const localVarPath = `/api/hotel/{hotelId}/AddHotelRoomType`.replace(
        `{${'hotelId'}}`,
        encodeURIComponent(String(hotelId))
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
        addHotelRoomTypeRequest,
        localVarRequestOptions,
        configuration
    );

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelIdAllRoomsGet - axios parameter creator
 *
 * @param {number} hotelId
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelIdAllRoomsGetAxiosParamCreator(
    hotelId: number,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'hotelId' is not null or undefined
    assertParamExists('apiHotelHotelIdAllRoomsGet', 'hotelId', hotelId);
    const localVarPath = `/api/hotel/{hotelId}/all-rooms`.replace(
        `{${'hotelId'}}`,
        encodeURIComponent(String(hotelId))
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelIdAssignMappingMappingIdPost - axios parameter creator
 *
 * @param {number} hotelId
 * @param {number} mappingId
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelIdAssignMappingMappingIdPostAxiosParamCreator(
    hotelId: number,
    mappingId: number,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'hotelId' is not null or undefined
    assertParamExists(
        'apiHotelHotelIdAssignMappingMappingIdPost',
        'hotelId',
        hotelId
    );
    // verify required parameter 'mappingId' is not null or undefined
    assertParamExists(
        'apiHotelHotelIdAssignMappingMappingIdPost',
        'mappingId',
        mappingId
    );
    const localVarPath = `/api/hotel/{hotelId}/assign-mapping/{mappingId}`
        .replace(`{${'hotelId'}}`, encodeURIComponent(String(hotelId)))
        .replace(`{${'mappingId'}}`, encodeURIComponent(String(mappingId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelIdGet - axios parameter creator
 *
 * @param {number} hotelId
 * @param {string} [from]
 * @param {string} [to]
 * @param {number} [adultCount]
 * @param {number} [childrenCount]
 * @param {number} [roomCount]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelIdGetAxiosParamCreator(
    hotelId: number,
    from?: string,
    to?: string,
    adultCount?: number,
    childrenCount?: number,
    roomCount?: number,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'hotelId' is not null or undefined
    assertParamExists('apiHotelHotelIdGet', 'hotelId', hotelId);
    const localVarPath = `/api/hotel/{hotelId}`.replace(
        `{${'hotelId'}}`,
        encodeURIComponent(String(hotelId))
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    if (from !== undefined) {
        localVarQueryParameter['from'] =
            (from as any) instanceof Date ? (from as any).toISOString() : from;
    }

    if (to !== undefined) {
        localVarQueryParameter['to'] =
            (to as any) instanceof Date ? (to as any).toISOString() : to;
    }

    if (adultCount !== undefined) {
        localVarQueryParameter['adultCount'] = adultCount;
    }

    if (childrenCount !== undefined) {
        localVarQueryParameter['childrenCount'] = childrenCount;
    }

    if (roomCount !== undefined) {
        localVarQueryParameter['roomCount'] = roomCount;
    }

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelIdGetHotelAmenitiesGet - axios parameter creator
 *
 * @param {number} hotelId
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelIdGetHotelAmenitiesGetAxiosParamCreator(
    hotelId: number,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'hotelId' is not null or undefined
    assertParamExists(
        'apiHotelHotelIdGetHotelAmenitiesGet',
        'hotelId',
        hotelId
    );
    const localVarPath = `/api/hotel/{hotelId}/GetHotelAmenities`.replace(
        `{${'hotelId'}}`,
        encodeURIComponent(String(hotelId))
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelIdPopularPlacesGet - axios parameter creator
 *
 * @param {number} hotelId
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelIdPopularPlacesGetAxiosParamCreator(
    hotelId: number,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'hotelId' is not null or undefined
    assertParamExists('apiHotelHotelIdPopularPlacesGet', 'hotelId', hotelId);
    const localVarPath = `/api/hotel/{hotelId}/PopularPlaces`.replace(
        `{${'hotelId'}}`,
        encodeURIComponent(String(hotelId))
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelIdPopularPlacesPopularPlaceIdDelete - axios parameter creator
 *
 * @param {number} hotelId
 * @param {number} popularPlaceId
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelIdPopularPlacesPopularPlaceIdDeleteAxiosParamCreator(
    hotelId: number,
    popularPlaceId: number,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'hotelId' is not null or undefined
    assertParamExists(
        'apiHotelHotelIdPopularPlacesPopularPlaceIdDelete',
        'hotelId',
        hotelId
    );
    // verify required parameter 'popularPlaceId' is not null or undefined
    assertParamExists(
        'apiHotelHotelIdPopularPlacesPopularPlaceIdDelete',
        'popularPlaceId',
        popularPlaceId
    );
    const localVarPath = `/api/hotel/{hotelId}/PopularPlaces/{popularPlaceId}`
        .replace(`{${'hotelId'}}`, encodeURIComponent(String(hotelId)))
        .replace(
            `{${'popularPlaceId'}}`,
            encodeURIComponent(String(popularPlaceId))
        );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelIdPopularPlacesPost - axios parameter creator
 *
 * @param {number} hotelId
 * @param {AddHotelPopularPlaceRequest} [addHotelPopularPlaceRequest]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelIdPopularPlacesPostAxiosParamCreator(
    hotelId: number,
    addHotelPopularPlaceRequest?: AddHotelPopularPlaceRequest,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'hotelId' is not null or undefined
    assertParamExists('apiHotelHotelIdPopularPlacesPost', 'hotelId', hotelId);
    const localVarPath = `/api/hotel/{hotelId}/PopularPlaces`.replace(
        `{${'hotelId'}}`,
        encodeURIComponent(String(hotelId))
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
        addHotelPopularPlaceRequest,
        localVarRequestOptions,
        configuration
    );

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelIdPopularPlacesPut - axios parameter creator
 *
 * @param {number} hotelId
 * @param {AddHotelPopularPlaceRequest} [addHotelPopularPlaceRequest]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelIdPopularPlacesPutAxiosParamCreator(
    hotelId: number,
    addHotelPopularPlaceRequest?: AddHotelPopularPlaceRequest,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'hotelId' is not null or undefined
    assertParamExists('apiHotelHotelIdPopularPlacesPut', 'hotelId', hotelId);
    const localVarPath = `/api/hotel/{hotelId}/PopularPlaces`.replace(
        `{${'hotelId'}}`,
        encodeURIComponent(String(hotelId))
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
        addHotelPopularPlaceRequest,
        localVarRequestOptions,
        configuration
    );

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelIdRoomtypesUnusedDelete - axios parameter creator
 *
 * @param {number} hotelId
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelIdRoomtypesUnusedDeleteAxiosParamCreator(
    hotelId: number,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'hotelId' is not null or undefined
    assertParamExists(
        'apiHotelHotelIdRoomtypesUnusedDelete',
        'hotelId',
        hotelId
    );
    const localVarPath = `/api/hotel/{hotelId}/roomtypes/unused`.replace(
        `{${'hotelId'}}`,
        encodeURIComponent(String(hotelId))
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelIdStaticGet - axios parameter creator
 *
 * @param {number} hotelId
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelIdStaticGetAxiosParamCreator(
    hotelId: number,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'hotelId' is not null or undefined
    assertParamExists('apiHotelHotelIdStaticGet', 'hotelId', hotelId);
    const localVarPath = `/api/hotel/{hotelId}/static`.replace(
        `{${'hotelId'}}`,
        encodeURIComponent(String(hotelId))
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelIdTagGet - axios parameter creator
 *
 * @param {number} hotelId
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelIdTagGetAxiosParamCreator(
    hotelId: number,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'hotelId' is not null or undefined
    assertParamExists('apiHotelHotelIdTagGet', 'hotelId', hotelId);
    const localVarPath = `/api/hotel/{hotelId}/tag`.replace(
        `{${'hotelId'}}`,
        encodeURIComponent(String(hotelId))
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelIdToggleHotelRoomTypePut - axios parameter creator
 *
 * @param {number} hotelId
 * @param {number} [roomTypeId]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelIdToggleHotelRoomTypePutAxiosParamCreator(
    hotelId: number,
    roomTypeId?: number,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'hotelId' is not null or undefined
    assertParamExists(
        'apiHotelHotelIdToggleHotelRoomTypePut',
        'hotelId',
        hotelId
    );
    const localVarPath = `/api/hotel/{hotelId}/ToggleHotelRoomType`.replace(
        `{${'hotelId'}}`,
        encodeURIComponent(String(hotelId))
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    if (roomTypeId !== undefined) {
        localVarQueryParameter['roomTypeId'] = roomTypeId;
    }

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelIdUpdateHotelRoomTypePost - axios parameter creator
 *
 * @param {number} hotelId
 * @param {UpdateHotelRoomTypeRequest} [updateHotelRoomTypeRequest]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelIdUpdateHotelRoomTypePostAxiosParamCreator(
    hotelId: number,
    updateHotelRoomTypeRequest?: UpdateHotelRoomTypeRequest,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'hotelId' is not null or undefined
    assertParamExists(
        'apiHotelHotelIdUpdateHotelRoomTypePost',
        'hotelId',
        hotelId
    );
    const localVarPath = `/api/hotel/{hotelId}/UpdateHotelRoomType`.replace(
        `{${'hotelId'}}`,
        encodeURIComponent(String(hotelId))
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
        updateHotelRoomTypeRequest,
        localVarRequestOptions,
        configuration
    );

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelMappingListHotelIdGet - axios parameter creator
 *
 * @param {number} hotelId
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelMappingListHotelIdGetAxiosParamCreator(
    hotelId: number,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'hotelId' is not null or undefined
    assertParamExists('apiHotelHotelMappingListHotelIdGet', 'hotelId', hotelId);
    const localVarPath = `/api/hotel/HotelMappingList/{hotelId}`.replace(
        `{${'hotelId'}}`,
        encodeURIComponent(String(hotelId))
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelMarkupDetailGet - axios parameter creator
 *
 * @summary Get Hotel Markup Detail
 * @param {number} [idMarkup]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelMarkupDetailGetAxiosParamCreator(
    idMarkup?: number,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/HotelMarkupDetail`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    if (idMarkup !== undefined) {
        localVarQueryParameter['idMarkup'] = idMarkup;
    }

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelMarkupListGet - axios parameter creator
 *
 * @summary Get Hotel Markup List
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelMarkupListGetAxiosParamCreator(
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/HotelMarkupList`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelTypeListGet - axios parameter creator
 *
 * @summary Get Hotel Type List
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelTypeListGetAxiosParamCreator(
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/HotelTypeList`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelsAvailabilityByCityCityCodeGet - axios parameter creator
 *
 * @param {string} cityCode
 * @param {string} [from]
 * @param {string} [to]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelsAvailabilityByCityCityCodeGetAxiosParamCreator(
    cityCode: string,
    from?: string,
    to?: string,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'cityCode' is not null or undefined
    assertParamExists(
        'apiHotelHotelsAvailabilityByCityCityCodeGet',
        'cityCode',
        cityCode
    );
    const localVarPath =
        `/api/hotel/HotelsAvailabilityByCity/{cityCode}`.replace(
            `{${'cityCode'}}`,
            encodeURIComponent(String(cityCode))
        );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    if (from !== undefined) {
        localVarQueryParameter['from'] =
            (from as any) instanceof Date ? (from as any).toISOString() : from;
    }

    if (to !== undefined) {
        localVarQueryParameter['to'] =
            (to as any) instanceof Date ? (to as any).toISOString() : to;
    }

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelHotelsWithMessageGet - axios parameter creator
 *
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelHotelsWithMessageGetAxiosParamCreator(
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/HotelsWithMessage`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelLatitudeLongitudeNearByCitiesGet - axios parameter creator
 *
 * @param {number} latitude
 * @param {number} longitude
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelLatitudeLongitudeNearByCitiesGetAxiosParamCreator(
    latitude: number,
    longitude: number,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'latitude' is not null or undefined
    assertParamExists(
        'apiHotelLatitudeLongitudeNearByCitiesGet',
        'latitude',
        latitude
    );
    // verify required parameter 'longitude' is not null or undefined
    assertParamExists(
        'apiHotelLatitudeLongitudeNearByCitiesGet',
        'longitude',
        longitude
    );
    const localVarPath = `/api/hotel/{latitude}/{longitude}/NearByCities`
        .replace(`{${'latitude'}}`, encodeURIComponent(String(latitude)))
        .replace(`{${'longitude'}}`, encodeURIComponent(String(longitude)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelMessagePost - axios parameter creator
 *
 * @summary update message of hotel
 * @param {EditHotelMessageRequest} [editHotelMessageRequest]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelMessagePostAxiosParamCreator(
    editHotelMessageRequest?: EditHotelMessageRequest,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/Message`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
        editHotelMessageRequest,
        localVarRequestOptions,
        configuration
    );

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelOrphanHotelMappingsGet - axios parameter creator
 *
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelOrphanHotelMappingsGetAxiosParamCreator(
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/orphan-hotel-mappings`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelPost - axios parameter creator
 *
 * @param {CreateHotelRequest} [createHotelRequest]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelPostAxiosParamCreator(
    createHotelRequest?: CreateHotelRequest,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    const localVarPath = `/api/hotel`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
        createHotelRequest,
        localVarRequestOptions,
        configuration
    );

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelRemoveHotelPageCacheHotelIdDelete - axios parameter creator
 *
 * @summary this method remove hotel page cache by hotel id
 * @param {number} hotelId
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelRemoveHotelPageCacheHotelIdDeleteAxiosParamCreator(
    hotelId: number,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'hotelId' is not null or undefined
    assertParamExists(
        'apiHotelRemoveHotelPageCacheHotelIdDelete',
        'hotelId',
        hotelId
    );
    const localVarPath = `/api/hotel/RemoveHotelPageCache/{hotelId}`.replace(
        `{${'hotelId'}}`,
        encodeURIComponent(String(hotelId))
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelSortHotelMarkupPost - axios parameter creator
 *
 * @summary Sort Hotel Markups by Priority
 * @param {Array<SortHotelMarkupRequest>} [sortHotelMarkupRequest]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelSortHotelMarkupPostAxiosParamCreator(
    sortHotelMarkupRequest?: Array<SortHotelMarkupRequest>,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/SortHotelMarkup`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
        sortHotelMarkupRequest,
        localVarRequestOptions,
        configuration
    );

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelSpecialOfferListGet - axios parameter creator
 *
 * @summary Get Hotel Special Offer List
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelSpecialOfferListGetAxiosParamCreator(
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/SpecialOfferList`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelTagPost - axios parameter creator
 *
 * @param {CreateHotelTagRequest} [createHotelTagRequest]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelTagPostAxiosParamCreator(
    createHotelTagRequest?: CreateHotelTagRequest,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/tag`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
        createHotelTagRequest,
        localVarRequestOptions,
        configuration
    );

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelTagTagIdDelete - axios parameter creator
 *
 * @param {number} tagId
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelTagTagIdDeleteAxiosParamCreator(
    tagId: number,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'tagId' is not null or undefined
    assertParamExists('apiHotelTagTagIdDelete', 'tagId', tagId);
    const localVarPath = `/api/hotel/tag/{tagId}`.replace(
        `{${'tagId'}}`,
        encodeURIComponent(String(tagId))
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelToggleHotelCommentHotelIdHotelCommentIdIsActivePost - axios parameter creator
 *
 * @param {number} hotelId
 * @param {number} hotelCommentId
 * @param {boolean} isActive
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelToggleHotelCommentHotelIdHotelCommentIdIsActivePostAxiosParamCreator(
    hotelId: number,
    hotelCommentId: number,
    isActive: boolean,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'hotelId' is not null or undefined
    assertParamExists(
        'apiHotelToggleHotelCommentHotelIdHotelCommentIdIsActivePost',
        'hotelId',
        hotelId
    );
    // verify required parameter 'hotelCommentId' is not null or undefined
    assertParamExists(
        'apiHotelToggleHotelCommentHotelIdHotelCommentIdIsActivePost',
        'hotelCommentId',
        hotelCommentId
    );
    // verify required parameter 'isActive' is not null or undefined
    assertParamExists(
        'apiHotelToggleHotelCommentHotelIdHotelCommentIdIsActivePost',
        'isActive',
        isActive
    );
    const localVarPath =
        `/api/hotel/ToggleHotelComment/{hotelId}/{hotelCommentId}/{isActive}`
            .replace(`{${'hotelId'}}`, encodeURIComponent(String(hotelId)))
            .replace(
                `{${'hotelCommentId'}}`,
                encodeURIComponent(String(hotelCommentId))
            )
            .replace(`{${'isActive'}}`, encodeURIComponent(String(isActive)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelToggleHotelMappingHotelIdHotelMappingIdPost - axios parameter creator
 *
 * @param {number} hotelId
 * @param {number} hotelMappingId
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelToggleHotelMappingHotelIdHotelMappingIdPostAxiosParamCreator(
    hotelId: number,
    hotelMappingId: number,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'hotelId' is not null or undefined
    assertParamExists(
        'apiHotelToggleHotelMappingHotelIdHotelMappingIdPost',
        'hotelId',
        hotelId
    );
    // verify required parameter 'hotelMappingId' is not null or undefined
    assertParamExists(
        'apiHotelToggleHotelMappingHotelIdHotelMappingIdPost',
        'hotelMappingId',
        hotelMappingId
    );
    const localVarPath =
        `/api/hotel/ToggleHotelMapping/{hotelId}/{hotelMappingId}`
            .replace(`{${'hotelId'}}`, encodeURIComponent(String(hotelId)))
            .replace(
                `{${'hotelMappingId'}}`,
                encodeURIComponent(String(hotelMappingId))
            );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelToggleHotelMappingSaleEnableHotelMappingIdSaleEnablePost - axios parameter creator
 *
 * @param {number} hotelMappingId
 * @param {boolean} saleEnable
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelToggleHotelMappingSaleEnableHotelMappingIdSaleEnablePostAxiosParamCreator(
    hotelMappingId: number,
    saleEnable: boolean,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'hotelMappingId' is not null or undefined
    assertParamExists(
        'apiHotelToggleHotelMappingSaleEnableHotelMappingIdSaleEnablePost',
        'hotelMappingId',
        hotelMappingId
    );
    // verify required parameter 'saleEnable' is not null or undefined
    assertParamExists(
        'apiHotelToggleHotelMappingSaleEnableHotelMappingIdSaleEnablePost',
        'saleEnable',
        saleEnable
    );
    const localVarPath =
        `/api/hotel/toggleHotelMappingSaleEnable/{hotelMappingId}/{saleEnable}`
            .replace(
                `{${'hotelMappingId'}}`,
                encodeURIComponent(String(hotelMappingId))
            )
            .replace(
                `{${'saleEnable'}}`,
                encodeURIComponent(String(saleEnable))
            );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelUpdateAmenityPut - axios parameter creator
 *
 * @param {UpdateAmenityRequest} [updateAmenityRequest]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelUpdateAmenityPutAxiosParamCreator(
    updateAmenityRequest?: UpdateAmenityRequest,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/UpdateAmenity`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
        updateAmenityRequest,
        localVarRequestOptions,
        configuration
    );

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelUpdateHotelAmenitiesHotelIdPost - axios parameter creator
 *
 * @param {number} hotelId
 * @param {AddHotelAmenitiesRequest} [addHotelAmenitiesRequest]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelUpdateHotelAmenitiesHotelIdPostAxiosParamCreator(
    hotelId: number,
    addHotelAmenitiesRequest?: AddHotelAmenitiesRequest,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'hotelId' is not null or undefined
    assertParamExists(
        'apiHotelUpdateHotelAmenitiesHotelIdPost',
        'hotelId',
        hotelId
    );
    const localVarPath = `/api/hotel/UpdateHotelAmenities/{hotelId}`.replace(
        `{${'hotelId'}}`,
        encodeURIComponent(String(hotelId))
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
        addHotelAmenitiesRequest,
        localVarRequestOptions,
        configuration
    );

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelUpdateHotelBlockPost - axios parameter creator
 *
 * @summary Update Hotel Hotel Block with details
 * @param {UpdateHotelBlockRequest} [updateHotelBlockRequest]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelUpdateHotelBlockPostAxiosParamCreator(
    updateHotelBlockRequest?: UpdateHotelBlockRequest,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/UpdateHotelBlock`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
        updateHotelBlockRequest,
        localVarRequestOptions,
        configuration
    );

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelUpdateHotelCommentHotelIdPost - axios parameter creator
 *
 * @param {number} hotelId
 * @param {UpdateHotelCommentRequest} [updateHotelCommentRequest]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelUpdateHotelCommentHotelIdPostAxiosParamCreator(
    hotelId: number,
    updateHotelCommentRequest?: UpdateHotelCommentRequest,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'hotelId' is not null or undefined
    assertParamExists(
        'apiHotelUpdateHotelCommentHotelIdPost',
        'hotelId',
        hotelId
    );
    const localVarPath = `/api/hotel/UpdateHotelComment/{hotelId}`.replace(
        `{${'hotelId'}}`,
        encodeURIComponent(String(hotelId))
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
        updateHotelCommentRequest,
        localVarRequestOptions,
        configuration
    );

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelUpdateHotelImageFromProviderPost - axios parameter creator
 *
 * @param {UpdateHotelImageRequest} [updateHotelImageRequest]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelUpdateHotelImageFromProviderPostAxiosParamCreator(
    updateHotelImageRequest?: UpdateHotelImageRequest,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/updateHotelImageFromProvider`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
        updateHotelImageRequest,
        localVarRequestOptions,
        configuration
    );

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelUpdateHotelMappingHotelIdPost - axios parameter creator
 *
 * @param {number} hotelId
 * @param {UpdateHotelMappingRequest} [updateHotelMappingRequest]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelUpdateHotelMappingHotelIdPostAxiosParamCreator(
    hotelId: number,
    updateHotelMappingRequest?: UpdateHotelMappingRequest,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'hotelId' is not null or undefined
    assertParamExists(
        'apiHotelUpdateHotelMappingHotelIdPost',
        'hotelId',
        hotelId
    );
    const localVarPath = `/api/hotel/UpdateHotelMapping/{hotelId}`.replace(
        `{${'hotelId'}}`,
        encodeURIComponent(String(hotelId))
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
        updateHotelMappingRequest,
        localVarRequestOptions,
        configuration
    );

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelUpdateHotelMarkupPost - axios parameter creator
 *
 * @summary Update Hotel Markup with its constraints
 * @param {UpdateHotelMarkupDto} [updateHotelMarkupDto]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelUpdateHotelMarkupPostAxiosParamCreator(
    updateHotelMarkupDto?: UpdateHotelMarkupDto,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/UpdateHotelMarkup`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
        updateHotelMarkupDto,
        localVarRequestOptions,
        configuration
    );

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelUpdateHotelPost - axios parameter creator
 *
 * @param {UpdateHotelRequest} [updateHotelRequest]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelUpdateHotelPostAxiosParamCreator(
    updateHotelRequest?: UpdateHotelRequest,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/UpdateHotel`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
        updateHotelRequest,
        localVarRequestOptions,
        configuration
    );

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelUpdateHotelRoomTypeMappingHotelIdPost - axios parameter creator
 *
 * @param {number} hotelId
 * @param {UpdateHotelRoomTypeMappingRequest} [updateHotelRoomTypeMappingRequest]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelUpdateHotelRoomTypeMappingHotelIdPostAxiosParamCreator(
    hotelId: number,
    updateHotelRoomTypeMappingRequest?: UpdateHotelRoomTypeMappingRequest,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    // verify required parameter 'hotelId' is not null or undefined
    assertParamExists(
        'apiHotelUpdateHotelRoomTypeMappingHotelIdPost',
        'hotelId',
        hotelId
    );
    const localVarPath =
        `/api/hotel/UpdateHotelRoomTypeMapping/{hotelId}`.replace(
            `{${'hotelId'}}`,
            encodeURIComponent(String(hotelId))
        );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
        updateHotelRoomTypeMappingRequest,
        localVarRequestOptions,
        configuration
    );

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelUpdateSpecialOfferPost - axios parameter creator
 *
 * @summary update Special Offer with its items
 * @param {UpdateHotelSpecialOfferRequest} [updateHotelSpecialOfferRequest]
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelUpdateSpecialOfferPostAxiosParamCreator(
    updateHotelSpecialOfferRequest?: UpdateHotelSpecialOfferRequest,
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/UpdateSpecialOffer`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
        updateHotelSpecialOfferRequest,
        localVarRequestOptions,
        configuration
    );

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelApiApiHotelVisibleHotelBlockListGet - axios parameter creator
 *
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelApiApiHotelVisibleHotelBlockListGetAxiosParamCreator(
    options: AxiosRequestConfig = {},
    configuration?: Configuration
): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/VisibleHotelBlockList`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration);

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
    };

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiHotelAddAmenityPost operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelAddAmenityPostRequest
 */
export interface HotelApiApiHotelAddAmenityPostRequest {
    /**
     *
     * @type {AddAmenityRequest}
     * @memberof HotelApiApiHotelAddAmenityPost
     */
    readonly addAmenityRequest?: AddAmenityRequest;
}

/**
 * Request parameters for apiHotelAddHotelBlockPost operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelAddHotelBlockPostRequest
 */
export interface HotelApiApiHotelAddHotelBlockPostRequest {
    /**
     *
     * @type {AddHotelBlockRequest}
     * @memberof HotelApiApiHotelAddHotelBlockPost
     */
    readonly addHotelBlockRequest?: AddHotelBlockRequest;
}

/**
 * Request parameters for apiHotelAddHotelMarkupPost operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelAddHotelMarkupPostRequest
 */
export interface HotelApiApiHotelAddHotelMarkupPostRequest {
    /**
     *
     * @type {AddHotelMarkupRequest}
     * @memberof HotelApiApiHotelAddHotelMarkupPost
     */
    readonly addHotelMarkupRequest?: AddHotelMarkupRequest;
}

/**
 * Request parameters for apiHotelAddSpecialOfferPost operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelAddSpecialOfferPostRequest
 */
export interface HotelApiApiHotelAddSpecialOfferPostRequest {
    /**
     *
     * @type {AddHotelSpecialOfferRequest}
     * @memberof HotelApiApiHotelAddSpecialOfferPost
     */
    readonly addHotelSpecialOfferRequest?: AddHotelSpecialOfferRequest;
}

/**
 * Request parameters for apiHotelAmenitiesGet operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelAmenitiesGetRequest
 */
export interface HotelApiApiHotelAmenitiesGetRequest {
    /**
     *
     * @type {string}
     * @memberof HotelApiApiHotelAmenitiesGet
     */
    readonly searchTerm?: string;

    /**
     *
     * @type {boolean}
     * @memberof HotelApiApiHotelAmenitiesGet
     */
    readonly isForHotel?: boolean;

    /**
     *
     * @type {boolean}
     * @memberof HotelApiApiHotelAmenitiesGet
     */
    readonly isForRoom?: boolean;

    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelAmenitiesGet
     */
    readonly pageIndex?: number;

    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelAmenitiesGet
     */
    readonly pageSize?: number;
}

/**
 * Request parameters for apiHotelAmenityIdRemoveAmenityDelete operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelAmenityIdRemoveAmenityDeleteRequest
 */
export interface HotelApiApiHotelAmenityIdRemoveAmenityDeleteRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelAmenityIdRemoveAmenityDelete
     */
    readonly amenityId: number;
}

/**
 * Request parameters for apiHotelBackgroundHotelUpdatePost operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelBackgroundHotelUpdatePostRequest
 */
export interface HotelApiApiHotelBackgroundHotelUpdatePostRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelBackgroundHotelUpdatePost
     */
    readonly hotelId?: number;
}

/**
 * Request parameters for apiHotelChangeActivationHotelMarkupPut operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelChangeActivationHotelMarkupPutRequest
 */
export interface HotelApiApiHotelChangeActivationHotelMarkupPutRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelChangeActivationHotelMarkupPut
     */
    readonly markupId?: number;

    /**
     *
     * @type {boolean}
     * @memberof HotelApiApiHotelChangeActivationHotelMarkupPut
     */
    readonly isActive?: boolean;
}

/**
 * Request parameters for apiHotelCityNameGetAllHotelRoomGet operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelCityNameGetAllHotelRoomGetRequest
 */
export interface HotelApiApiHotelCityNameGetAllHotelRoomGetRequest {
    /**
     *
     * @type {string}
     * @memberof HotelApiApiHotelCityNameGetAllHotelRoomGet
     */
    readonly cityName: string;

    /**
     *
     * @type {string}
     * @memberof HotelApiApiHotelCityNameGetAllHotelRoomGet
     */
    readonly hotelName?: string;

    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelCityNameGetAllHotelRoomGet
     */
    readonly pageIndex?: number;

    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelCityNameGetAllHotelRoomGet
     */
    readonly pageSize?: number;
}

/**
 * Request parameters for apiHotelCityNameHotelNameGet operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelCityNameHotelNameGetRequest
 */
export interface HotelApiApiHotelCityNameHotelNameGetRequest {
    /**
     *
     * @type {string}
     * @memberof HotelApiApiHotelCityNameHotelNameGet
     */
    readonly cityName: string;

    /**
     *
     * @type {string}
     * @memberof HotelApiApiHotelCityNameHotelNameGet
     */
    readonly hotelName: string;

    /**
     *
     * @type {string}
     * @memberof HotelApiApiHotelCityNameHotelNameGet
     */
    readonly from?: string;

    /**
     *
     * @type {string}
     * @memberof HotelApiApiHotelCityNameHotelNameGet
     */
    readonly to?: string;

    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelCityNameHotelNameGet
     */
    readonly adultCount?: number;

    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelCityNameHotelNameGet
     */
    readonly childrenCount?: number;

    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelCityNameHotelNameGet
     */
    readonly roomCount?: number;
}

/**
 * Request parameters for apiHotelCityNameHotelNameRoomsGet operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelCityNameHotelNameRoomsGetRequest
 */
export interface HotelApiApiHotelCityNameHotelNameRoomsGetRequest {
    /**
     *
     * @type {string}
     * @memberof HotelApiApiHotelCityNameHotelNameRoomsGet
     */
    readonly cityName: string;

    /**
     *
     * @type {string}
     * @memberof HotelApiApiHotelCityNameHotelNameRoomsGet
     */
    readonly hotelName: string;

    /**
     *
     * @type {string}
     * @memberof HotelApiApiHotelCityNameHotelNameRoomsGet
     */
    readonly from?: string;

    /**
     *
     * @type {string}
     * @memberof HotelApiApiHotelCityNameHotelNameRoomsGet
     */
    readonly to?: string;

    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelCityNameHotelNameRoomsGet
     */
    readonly adultCount?: number;

    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelCityNameHotelNameRoomsGet
     */
    readonly childrenCount?: number;

    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelCityNameHotelNameRoomsGet
     */
    readonly roomCount?: number;
}

/**
 * Request parameters for apiHotelCityNameHotelNameStaticGet operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelCityNameHotelNameStaticGetRequest
 */
export interface HotelApiApiHotelCityNameHotelNameStaticGetRequest {
    /**
     *
     * @type {string}
     * @memberof HotelApiApiHotelCityNameHotelNameStaticGet
     */
    readonly cityName: string;

    /**
     *
     * @type {string}
     * @memberof HotelApiApiHotelCityNameHotelNameStaticGet
     */
    readonly hotelName: string;
}

/**
 * Request parameters for apiHotelCityTagGet operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelCityTagGetRequest
 */
export interface HotelApiApiHotelCityTagGetRequest {
    /**
     *
     * @type {string}
     * @memberof HotelApiApiHotelCityTagGet
     */
    readonly cityTag: string;
}

/**
 * Request parameters for apiHotelCreateHotelMappingHotelIdPost operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelCreateHotelMappingHotelIdPostRequest
 */
export interface HotelApiApiHotelCreateHotelMappingHotelIdPostRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelCreateHotelMappingHotelIdPost
     */
    readonly hotelId: number;

    /**
     *
     * @type {AddHotelMappingRequest}
     * @memberof HotelApiApiHotelCreateHotelMappingHotelIdPost
     */
    readonly addHotelMappingRequest?: AddHotelMappingRequest;
}

/**
 * Request parameters for apiHotelDeleteHotelBlockDelete operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelDeleteHotelBlockDeleteRequest
 */
export interface HotelApiApiHotelDeleteHotelBlockDeleteRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelDeleteHotelBlockDelete
     */
    readonly blockId?: number;
}

/**
 * Request parameters for apiHotelDeleteHotelMappingHotelIdHotelMappingIdDelete operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelDeleteHotelMappingHotelIdHotelMappingIdDeleteRequest
 */
export interface HotelApiApiHotelDeleteHotelMappingHotelIdHotelMappingIdDeleteRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelDeleteHotelMappingHotelIdHotelMappingIdDelete
     */
    readonly hotelId: number;

    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelDeleteHotelMappingHotelIdHotelMappingIdDelete
     */
    readonly hotelMappingId: number;
}

/**
 * Request parameters for apiHotelDeleteHotelMarkupDelete operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelDeleteHotelMarkupDeleteRequest
 */
export interface HotelApiApiHotelDeleteHotelMarkupDeleteRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelDeleteHotelMarkupDelete
     */
    readonly markupId?: number;
}

/**
 * Request parameters for apiHotelDeleteSpecialOfferDelete operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelDeleteSpecialOfferDeleteRequest
 */
export interface HotelApiApiHotelDeleteSpecialOfferDeleteRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelDeleteSpecialOfferDelete
     */
    readonly specialOfferId?: number;
}

/**
 * Request parameters for apiHotelGetHotelsWithRoomsCityIdGet operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelGetHotelsWithRoomsCityIdGetRequest
 */
export interface HotelApiApiHotelGetHotelsWithRoomsCityIdGetRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelGetHotelsWithRoomsCityIdGet
     */
    readonly cityId: number;

    /**
     *
     * @type {string}
     * @memberof HotelApiApiHotelGetHotelsWithRoomsCityIdGet
     */
    readonly from?: string;

    /**
     *
     * @type {string}
     * @memberof HotelApiApiHotelGetHotelsWithRoomsCityIdGet
     */
    readonly to?: string;

    /**
     *
     * @type {boolean}
     * @memberof HotelApiApiHotelGetHotelsWithRoomsCityIdGet
     */
    readonly isOnlyDb?: boolean;
}

/**
 * Request parameters for apiHotelHotelAutoCompleteListGet operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelHotelAutoCompleteListGetRequest
 */
export interface HotelApiApiHotelHotelAutoCompleteListGetRequest {
    /**
     *
     * @type {string}
     * @memberof HotelApiApiHotelHotelAutoCompleteListGet
     */
    readonly searchTerm?: string;
}

/**
 * Request parameters for apiHotelHotelAvailabilityCityNameHotelNameGet operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelHotelAvailabilityCityNameHotelNameGetRequest
 */
export interface HotelApiApiHotelHotelAvailabilityCityNameHotelNameGetRequest {
    /**
     *
     * @type {string}
     * @memberof HotelApiApiHotelHotelAvailabilityCityNameHotelNameGet
     */
    readonly cityName: string;

    /**
     *
     * @type {string}
     * @memberof HotelApiApiHotelHotelAvailabilityCityNameHotelNameGet
     */
    readonly hotelName: string;

    /**
     *
     * @type {string}
     * @memberof HotelApiApiHotelHotelAvailabilityCityNameHotelNameGet
     */
    readonly from?: string;

    /**
     *
     * @type {string}
     * @memberof HotelApiApiHotelHotelAvailabilityCityNameHotelNameGet
     */
    readonly to?: string;
}

/**
 * Request parameters for apiHotelHotelBlockDetailGet operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelHotelBlockDetailGetRequest
 */
export interface HotelApiApiHotelHotelBlockDetailGetRequest {
    /**
     *
     * @type {string}
     * @memberof HotelApiApiHotelHotelBlockDetailGet
     */
    readonly cityName?: string;
}

/**
 * Request parameters for apiHotelHotelBlocksGet operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelHotelBlocksGetRequest
 */
export interface HotelApiApiHotelHotelBlocksGetRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelHotelBlocksGet
     */
    readonly blockId?: number;
}

/**
 * Request parameters for apiHotelHotelCommentCommentIdDelete operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelHotelCommentCommentIdDeleteRequest
 */
export interface HotelApiApiHotelHotelCommentCommentIdDeleteRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelHotelCommentCommentIdDelete
     */
    readonly commentId: number;
}

/**
 * Request parameters for apiHotelHotelCommentDetailHotelCommentIdGet operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelHotelCommentDetailHotelCommentIdGetRequest
 */
export interface HotelApiApiHotelHotelCommentDetailHotelCommentIdGetRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelHotelCommentDetailHotelCommentIdGet
     */
    readonly hotelCommentId: number;
}

/**
 * Request parameters for apiHotelHotelCommentListHotelIdGet operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelHotelCommentListHotelIdGetRequest
 */
export interface HotelApiApiHotelHotelCommentListHotelIdGetRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelHotelCommentListHotelIdGet
     */
    readonly hotelId: number;

    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelHotelCommentListHotelIdGet
     */
    readonly pageIndex?: number;

    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelHotelCommentListHotelIdGet
     */
    readonly pageSize?: number;

    /**
     *
     * @type {boolean}
     * @memberof HotelApiApiHotelHotelCommentListHotelIdGet
     */
    readonly isActive?: boolean;
}

/**
 * Request parameters for apiHotelHotelCommentPost operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelHotelCommentPostRequest
 */
export interface HotelApiApiHotelHotelCommentPostRequest {
    /**
     *
     * @type {CreateHotelCommentRequest}
     * @memberof HotelApiApiHotelHotelCommentPost
     */
    readonly createHotelCommentRequest?: CreateHotelCommentRequest;
}

/**
 * Request parameters for apiHotelHotelFullDetailsHotelIdGet operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelHotelFullDetailsHotelIdGetRequest
 */
export interface HotelApiApiHotelHotelFullDetailsHotelIdGetRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelHotelFullDetailsHotelIdGet
     */
    readonly hotelId: number;
}

/**
 * Request parameters for apiHotelHotelIdAddCommentPost operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelHotelIdAddCommentPostRequest
 */
export interface HotelApiApiHotelHotelIdAddCommentPostRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelHotelIdAddCommentPost
     */
    readonly hotelId: number;

    /**
     *
     * @type {string}
     * @memberof HotelApiApiHotelHotelIdAddCommentPost
     */
    readonly body?: string;

    /**
     *
     * @type {boolean}
     * @memberof HotelApiApiHotelHotelIdAddCommentPost
     */
    readonly reserved?: boolean;

    /**
     *
     * @type {Array<UpdateCommentRatingFactor>}
     * @memberof HotelApiApiHotelHotelIdAddCommentPost
     */
    readonly commentRatings?: Array<UpdateCommentRatingFactor>;

    /**
     *
     * @type {Array<File>}
     * @memberof HotelApiApiHotelHotelIdAddCommentPost
     */
    readonly photos?: Array<File>;

    /**
     *
     * @type {string}
     * @memberof HotelApiApiHotelHotelIdAddCommentPost
     */
    readonly dNTCaptchaText?: string;

    /**
     *
     * @type {string}
     * @memberof HotelApiApiHotelHotelIdAddCommentPost
     */
    readonly dNTCaptchaInputText?: string;

    /**
     *
     * @type {string}
     * @memberof HotelApiApiHotelHotelIdAddCommentPost
     */
    readonly dNTCaptchaToken?: string;
}

/**
 * Request parameters for apiHotelHotelIdAddHotelRoomTypePost operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelHotelIdAddHotelRoomTypePostRequest
 */
export interface HotelApiApiHotelHotelIdAddHotelRoomTypePostRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelHotelIdAddHotelRoomTypePost
     */
    readonly hotelId: number;

    /**
     *
     * @type {AddHotelRoomTypeRequest}
     * @memberof HotelApiApiHotelHotelIdAddHotelRoomTypePost
     */
    readonly addHotelRoomTypeRequest?: AddHotelRoomTypeRequest;
}

/**
 * Request parameters for apiHotelHotelIdAllRoomsGet operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelHotelIdAllRoomsGetRequest
 */
export interface HotelApiApiHotelHotelIdAllRoomsGetRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelHotelIdAllRoomsGet
     */
    readonly hotelId: number;
}

/**
 * Request parameters for apiHotelHotelIdAssignMappingMappingIdPost operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelHotelIdAssignMappingMappingIdPostRequest
 */
export interface HotelApiApiHotelHotelIdAssignMappingMappingIdPostRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelHotelIdAssignMappingMappingIdPost
     */
    readonly hotelId: number;

    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelHotelIdAssignMappingMappingIdPost
     */
    readonly mappingId: number;
}

/**
 * Request parameters for apiHotelHotelIdGet operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelHotelIdGetRequest
 */
export interface HotelApiApiHotelHotelIdGetRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelHotelIdGet
     */
    readonly hotelId: number;

    /**
     *
     * @type {string}
     * @memberof HotelApiApiHotelHotelIdGet
     */
    readonly from?: string;

    /**
     *
     * @type {string}
     * @memberof HotelApiApiHotelHotelIdGet
     */
    readonly to?: string;

    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelHotelIdGet
     */
    readonly adultCount?: number;

    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelHotelIdGet
     */
    readonly childrenCount?: number;

    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelHotelIdGet
     */
    readonly roomCount?: number;
}

/**
 * Request parameters for apiHotelHotelIdGetHotelAmenitiesGet operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelHotelIdGetHotelAmenitiesGetRequest
 */
export interface HotelApiApiHotelHotelIdGetHotelAmenitiesGetRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelHotelIdGetHotelAmenitiesGet
     */
    readonly hotelId: number;
}

/**
 * Request parameters for apiHotelHotelIdPopularPlacesGet operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelHotelIdPopularPlacesGetRequest
 */
export interface HotelApiApiHotelHotelIdPopularPlacesGetRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelHotelIdPopularPlacesGet
     */
    readonly hotelId: number;
}

/**
 * Request parameters for apiHotelHotelIdPopularPlacesPopularPlaceIdDelete operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelHotelIdPopularPlacesPopularPlaceIdDeleteRequest
 */
export interface HotelApiApiHotelHotelIdPopularPlacesPopularPlaceIdDeleteRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelHotelIdPopularPlacesPopularPlaceIdDelete
     */
    readonly hotelId: number;

    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelHotelIdPopularPlacesPopularPlaceIdDelete
     */
    readonly popularPlaceId: number;
}

/**
 * Request parameters for apiHotelHotelIdPopularPlacesPost operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelHotelIdPopularPlacesPostRequest
 */
export interface HotelApiApiHotelHotelIdPopularPlacesPostRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelHotelIdPopularPlacesPost
     */
    readonly hotelId: number;

    /**
     *
     * @type {AddHotelPopularPlaceRequest}
     * @memberof HotelApiApiHotelHotelIdPopularPlacesPost
     */
    readonly addHotelPopularPlaceRequest?: AddHotelPopularPlaceRequest;
}

/**
 * Request parameters for apiHotelHotelIdPopularPlacesPut operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelHotelIdPopularPlacesPutRequest
 */
export interface HotelApiApiHotelHotelIdPopularPlacesPutRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelHotelIdPopularPlacesPut
     */
    readonly hotelId: number;

    /**
     *
     * @type {AddHotelPopularPlaceRequest}
     * @memberof HotelApiApiHotelHotelIdPopularPlacesPut
     */
    readonly addHotelPopularPlaceRequest?: AddHotelPopularPlaceRequest;
}

/**
 * Request parameters for apiHotelHotelIdRoomtypesUnusedDelete operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelHotelIdRoomtypesUnusedDeleteRequest
 */
export interface HotelApiApiHotelHotelIdRoomtypesUnusedDeleteRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelHotelIdRoomtypesUnusedDelete
     */
    readonly hotelId: number;
}

/**
 * Request parameters for apiHotelHotelIdStaticGet operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelHotelIdStaticGetRequest
 */
export interface HotelApiApiHotelHotelIdStaticGetRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelHotelIdStaticGet
     */
    readonly hotelId: number;
}

/**
 * Request parameters for apiHotelHotelIdTagGet operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelHotelIdTagGetRequest
 */
export interface HotelApiApiHotelHotelIdTagGetRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelHotelIdTagGet
     */
    readonly hotelId: number;
}

/**
 * Request parameters for apiHotelHotelIdToggleHotelRoomTypePut operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelHotelIdToggleHotelRoomTypePutRequest
 */
export interface HotelApiApiHotelHotelIdToggleHotelRoomTypePutRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelHotelIdToggleHotelRoomTypePut
     */
    readonly hotelId: number;

    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelHotelIdToggleHotelRoomTypePut
     */
    readonly roomTypeId?: number;
}

/**
 * Request parameters for apiHotelHotelIdUpdateHotelRoomTypePost operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelHotelIdUpdateHotelRoomTypePostRequest
 */
export interface HotelApiApiHotelHotelIdUpdateHotelRoomTypePostRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelHotelIdUpdateHotelRoomTypePost
     */
    readonly hotelId: number;

    /**
     *
     * @type {UpdateHotelRoomTypeRequest}
     * @memberof HotelApiApiHotelHotelIdUpdateHotelRoomTypePost
     */
    readonly updateHotelRoomTypeRequest?: UpdateHotelRoomTypeRequest;
}

/**
 * Request parameters for apiHotelHotelMappingListHotelIdGet operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelHotelMappingListHotelIdGetRequest
 */
export interface HotelApiApiHotelHotelMappingListHotelIdGetRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelHotelMappingListHotelIdGet
     */
    readonly hotelId: number;
}

/**
 * Request parameters for apiHotelHotelMarkupDetailGet operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelHotelMarkupDetailGetRequest
 */
export interface HotelApiApiHotelHotelMarkupDetailGetRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelHotelMarkupDetailGet
     */
    readonly idMarkup?: number;
}

/**
 * Request parameters for apiHotelHotelsAvailabilityByCityCityCodeGet operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelHotelsAvailabilityByCityCityCodeGetRequest
 */
export interface HotelApiApiHotelHotelsAvailabilityByCityCityCodeGetRequest {
    /**
     *
     * @type {string}
     * @memberof HotelApiApiHotelHotelsAvailabilityByCityCityCodeGet
     */
    readonly cityCode: string;

    /**
     *
     * @type {string}
     * @memberof HotelApiApiHotelHotelsAvailabilityByCityCityCodeGet
     */
    readonly from?: string;

    /**
     *
     * @type {string}
     * @memberof HotelApiApiHotelHotelsAvailabilityByCityCityCodeGet
     */
    readonly to?: string;
}

/**
 * Request parameters for apiHotelLatitudeLongitudeNearByCitiesGet operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelLatitudeLongitudeNearByCitiesGetRequest
 */
export interface HotelApiApiHotelLatitudeLongitudeNearByCitiesGetRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelLatitudeLongitudeNearByCitiesGet
     */
    readonly latitude: number;

    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelLatitudeLongitudeNearByCitiesGet
     */
    readonly longitude: number;
}

/**
 * Request parameters for apiHotelMessagePost operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelMessagePostRequest
 */
export interface HotelApiApiHotelMessagePostRequest {
    /**
     *
     * @type {EditHotelMessageRequest}
     * @memberof HotelApiApiHotelMessagePost
     */
    readonly editHotelMessageRequest?: EditHotelMessageRequest;
}

/**
 * Request parameters for apiHotelPost operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelPostRequest
 */
export interface HotelApiApiHotelPostRequest {
    /**
     *
     * @type {CreateHotelRequest}
     * @memberof HotelApiApiHotelPost
     */
    readonly createHotelRequest?: CreateHotelRequest;
}

/**
 * Request parameters for apiHotelRemoveHotelPageCacheHotelIdDelete operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelRemoveHotelPageCacheHotelIdDeleteRequest
 */
export interface HotelApiApiHotelRemoveHotelPageCacheHotelIdDeleteRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelRemoveHotelPageCacheHotelIdDelete
     */
    readonly hotelId: number;
}

/**
 * Request parameters for apiHotelSortHotelMarkupPost operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelSortHotelMarkupPostRequest
 */
export interface HotelApiApiHotelSortHotelMarkupPostRequest {
    /**
     *
     * @type {Array<SortHotelMarkupRequest>}
     * @memberof HotelApiApiHotelSortHotelMarkupPost
     */
    readonly sortHotelMarkupRequest?: Array<SortHotelMarkupRequest>;
}

/**
 * Request parameters for apiHotelTagPost operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelTagPostRequest
 */
export interface HotelApiApiHotelTagPostRequest {
    /**
     *
     * @type {CreateHotelTagRequest}
     * @memberof HotelApiApiHotelTagPost
     */
    readonly createHotelTagRequest?: CreateHotelTagRequest;
}

/**
 * Request parameters for apiHotelTagTagIdDelete operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelTagTagIdDeleteRequest
 */
export interface HotelApiApiHotelTagTagIdDeleteRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelTagTagIdDelete
     */
    readonly tagId: number;
}

/**
 * Request parameters for apiHotelToggleHotelCommentHotelIdHotelCommentIdIsActivePost operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelToggleHotelCommentHotelIdHotelCommentIdIsActivePostRequest
 */
export interface HotelApiApiHotelToggleHotelCommentHotelIdHotelCommentIdIsActivePostRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelToggleHotelCommentHotelIdHotelCommentIdIsActivePost
     */
    readonly hotelId: number;

    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelToggleHotelCommentHotelIdHotelCommentIdIsActivePost
     */
    readonly hotelCommentId: number;

    /**
     *
     * @type {boolean}
     * @memberof HotelApiApiHotelToggleHotelCommentHotelIdHotelCommentIdIsActivePost
     */
    readonly isActive: boolean;
}

/**
 * Request parameters for apiHotelToggleHotelMappingHotelIdHotelMappingIdPost operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelToggleHotelMappingHotelIdHotelMappingIdPostRequest
 */
export interface HotelApiApiHotelToggleHotelMappingHotelIdHotelMappingIdPostRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelToggleHotelMappingHotelIdHotelMappingIdPost
     */
    readonly hotelId: number;

    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelToggleHotelMappingHotelIdHotelMappingIdPost
     */
    readonly hotelMappingId: number;
}

/**
 * Request parameters for apiHotelToggleHotelMappingSaleEnableHotelMappingIdSaleEnablePost operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelToggleHotelMappingSaleEnableHotelMappingIdSaleEnablePostRequest
 */
export interface HotelApiApiHotelToggleHotelMappingSaleEnableHotelMappingIdSaleEnablePostRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelToggleHotelMappingSaleEnableHotelMappingIdSaleEnablePost
     */
    readonly hotelMappingId: number;

    /**
     *
     * @type {boolean}
     * @memberof HotelApiApiHotelToggleHotelMappingSaleEnableHotelMappingIdSaleEnablePost
     */
    readonly saleEnable: boolean;
}

/**
 * Request parameters for apiHotelUpdateAmenityPut operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelUpdateAmenityPutRequest
 */
export interface HotelApiApiHotelUpdateAmenityPutRequest {
    /**
     *
     * @type {UpdateAmenityRequest}
     * @memberof HotelApiApiHotelUpdateAmenityPut
     */
    readonly updateAmenityRequest?: UpdateAmenityRequest;
}

/**
 * Request parameters for apiHotelUpdateHotelAmenitiesHotelIdPost operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelUpdateHotelAmenitiesHotelIdPostRequest
 */
export interface HotelApiApiHotelUpdateHotelAmenitiesHotelIdPostRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelUpdateHotelAmenitiesHotelIdPost
     */
    readonly hotelId: number;

    /**
     *
     * @type {AddHotelAmenitiesRequest}
     * @memberof HotelApiApiHotelUpdateHotelAmenitiesHotelIdPost
     */
    readonly addHotelAmenitiesRequest?: AddHotelAmenitiesRequest;
}

/**
 * Request parameters for apiHotelUpdateHotelBlockPost operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelUpdateHotelBlockPostRequest
 */
export interface HotelApiApiHotelUpdateHotelBlockPostRequest {
    /**
     *
     * @type {UpdateHotelBlockRequest}
     * @memberof HotelApiApiHotelUpdateHotelBlockPost
     */
    readonly updateHotelBlockRequest?: UpdateHotelBlockRequest;
}

/**
 * Request parameters for apiHotelUpdateHotelCommentHotelIdPost operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelUpdateHotelCommentHotelIdPostRequest
 */
export interface HotelApiApiHotelUpdateHotelCommentHotelIdPostRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelUpdateHotelCommentHotelIdPost
     */
    readonly hotelId: number;

    /**
     *
     * @type {UpdateHotelCommentRequest}
     * @memberof HotelApiApiHotelUpdateHotelCommentHotelIdPost
     */
    readonly updateHotelCommentRequest?: UpdateHotelCommentRequest;
}

/**
 * Request parameters for apiHotelUpdateHotelImageFromProviderPost operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelUpdateHotelImageFromProviderPostRequest
 */
export interface HotelApiApiHotelUpdateHotelImageFromProviderPostRequest {
    /**
     *
     * @type {UpdateHotelImageRequest}
     * @memberof HotelApiApiHotelUpdateHotelImageFromProviderPost
     */
    readonly updateHotelImageRequest?: UpdateHotelImageRequest;
}

/**
 * Request parameters for apiHotelUpdateHotelMappingHotelIdPost operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelUpdateHotelMappingHotelIdPostRequest
 */
export interface HotelApiApiHotelUpdateHotelMappingHotelIdPostRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelUpdateHotelMappingHotelIdPost
     */
    readonly hotelId: number;

    /**
     *
     * @type {UpdateHotelMappingRequest}
     * @memberof HotelApiApiHotelUpdateHotelMappingHotelIdPost
     */
    readonly updateHotelMappingRequest?: UpdateHotelMappingRequest;
}

/**
 * Request parameters for apiHotelUpdateHotelMarkupPost operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelUpdateHotelMarkupPostRequest
 */
export interface HotelApiApiHotelUpdateHotelMarkupPostRequest {
    /**
     *
     * @type {UpdateHotelMarkupDto}
     * @memberof HotelApiApiHotelUpdateHotelMarkupPost
     */
    readonly updateHotelMarkupDto?: UpdateHotelMarkupDto;
}

/**
 * Request parameters for apiHotelUpdateHotelPost operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelUpdateHotelPostRequest
 */
export interface HotelApiApiHotelUpdateHotelPostRequest {
    /**
     *
     * @type {UpdateHotelRequest}
     * @memberof HotelApiApiHotelUpdateHotelPost
     */
    readonly updateHotelRequest?: UpdateHotelRequest;
}

/**
 * Request parameters for apiHotelUpdateHotelRoomTypeMappingHotelIdPost operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelUpdateHotelRoomTypeMappingHotelIdPostRequest
 */
export interface HotelApiApiHotelUpdateHotelRoomTypeMappingHotelIdPostRequest {
    /**
     *
     * @type {number}
     * @memberof HotelApiApiHotelUpdateHotelRoomTypeMappingHotelIdPost
     */
    readonly hotelId: number;

    /**
     *
     * @type {UpdateHotelRoomTypeMappingRequest}
     * @memberof HotelApiApiHotelUpdateHotelRoomTypeMappingHotelIdPost
     */
    readonly updateHotelRoomTypeMappingRequest?: UpdateHotelRoomTypeMappingRequest;
}

/**
 * Request parameters for apiHotelUpdateSpecialOfferPost operation in HotelApi.
 * @export
 * @interface HotelApiApiHotelUpdateSpecialOfferPostRequest
 */
export interface HotelApiApiHotelUpdateSpecialOfferPostRequest {
    /**
     *
     * @type {UpdateHotelSpecialOfferRequest}
     * @memberof HotelApiApiHotelUpdateSpecialOfferPost
     */
    readonly updateHotelSpecialOfferRequest?: UpdateHotelSpecialOfferRequest;
}

/**
 *
 * @param {HotelApiApiHotelAddAmenityPostRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelAddAmenityPost(
    requestParameters: HotelApiApiHotelAddAmenityPostRequest = {},
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelAddAmenityPostAxiosParamCreator(
            requestParameters.addAmenityRequest,
            options,
            configuration
        );
    const request: () => AxiosPromise<void> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @summary Add Hotel Block with details
 * @param {HotelApiApiHotelAddHotelBlockPostRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelAddHotelBlockPost(
    requestParameters: HotelApiApiHotelAddHotelBlockPostRequest = {},
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelAddHotelBlockPostAxiosParamCreator(
            requestParameters.addHotelBlockRequest,
            options,
            configuration
        );
    const request: () => AxiosPromise<void> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @summary Add Hotel Markup with its constraints
 * @param {HotelApiApiHotelAddHotelMarkupPostRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelAddHotelMarkupPost(
    requestParameters: HotelApiApiHotelAddHotelMarkupPostRequest = {},
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelAddHotelMarkupPostAxiosParamCreator(
            requestParameters.addHotelMarkupRequest,
            options,
            configuration
        );
    const request: () => AxiosPromise<void> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @summary Add Special Offer with its items
 * @param {HotelApiApiHotelAddSpecialOfferPostRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelAddSpecialOfferPost(
    requestParameters: HotelApiApiHotelAddSpecialOfferPostRequest = {},
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelAddSpecialOfferPostAxiosParamCreator(
            requestParameters.addHotelSpecialOfferRequest,
            options,
            configuration
        );
    const request: () => AxiosPromise<void> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @summary Get Amenity List
 * @param {HotelApiApiHotelAmenitiesGetRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelAmenitiesGet(
    requestParameters: HotelApiApiHotelAmenitiesGetRequest = {},
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelAmenitiesGetAxiosParamCreator(
            requestParameters.searchTerm,
            requestParameters.isForHotel,
            requestParameters.isForRoom,
            requestParameters.pageIndex,
            requestParameters.pageSize,
            options,
            configuration
        );
    const request: () => AxiosPromise<AmenityListResponse> =
        createRequestFunction(
            localVarAxiosArgs,
            globalAxios,
            BASE_PATH,
            configuration
        );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelAmenityIdRemoveAmenityDeleteRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelAmenityIdRemoveAmenityDelete(
    requestParameters: HotelApiApiHotelAmenityIdRemoveAmenityDeleteRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelAmenityIdRemoveAmenityDeleteAxiosParamCreator(
            requestParameters.amenityId,
            options,
            configuration
        );
    const request: () => AxiosPromise<void> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelBackgroundHotelUpdatePostRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelBackgroundHotelUpdatePost(
    requestParameters: HotelApiApiHotelBackgroundHotelUpdatePostRequest = {},
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelBackgroundHotelUpdatePostAxiosParamCreator(
            requestParameters.hotelId,
            options,
            configuration
        );
    const request: () => AxiosPromise<void> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @summary Active and deActive markups with their Ids
 * @param {HotelApiApiHotelChangeActivationHotelMarkupPutRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelChangeActivationHotelMarkupPut(
    requestParameters: HotelApiApiHotelChangeActivationHotelMarkupPutRequest = {},
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelChangeActivationHotelMarkupPutAxiosParamCreator(
            requestParameters.markupId,
            requestParameters.isActive,
            options,
            configuration
        );
    const request: () => AxiosPromise<void> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @summary Get City List (Id and PersianName)
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelCityListGet(
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelCityListGetAxiosParamCreator(
            options,
            configuration
        );
    const request: () => AxiosPromise<CityListResponse> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelCityNameGetAllHotelRoomGetRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelCityNameGetAllHotelRoomGet(
    requestParameters: HotelApiApiHotelCityNameGetAllHotelRoomGetRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelCityNameGetAllHotelRoomGetAxiosParamCreator(
            requestParameters.cityName,
            requestParameters.hotelName,
            requestParameters.pageIndex,
            requestParameters.pageSize,
            options,
            configuration
        );
    const request: () => AxiosPromise<HotelShortDetailResponse> =
        createRequestFunction(
            localVarAxiosArgs,
            globalAxios,
            BASE_PATH,
            configuration
        );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelCityNameHotelNameGetRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelCityNameHotelNameGet(
    requestParameters: HotelApiApiHotelCityNameHotelNameGetRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelCityNameHotelNameGetAxiosParamCreator(
            requestParameters.cityName,
            requestParameters.hotelName,
            requestParameters.from,
            requestParameters.to,
            requestParameters.adultCount,
            requestParameters.childrenCount,
            requestParameters.roomCount,
            options,
            configuration
        );
    const request: () => AxiosPromise<HotelResponse> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelCityNameHotelNameRoomsGetRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelCityNameHotelNameRoomsGet(
    requestParameters: HotelApiApiHotelCityNameHotelNameRoomsGetRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelCityNameHotelNameRoomsGetAxiosParamCreator(
            requestParameters.cityName,
            requestParameters.hotelName,
            requestParameters.from,
            requestParameters.to,
            requestParameters.adultCount,
            requestParameters.childrenCount,
            requestParameters.roomCount,
            options,
            configuration
        );
    const request: () => AxiosPromise<RoomsResponse> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelCityNameHotelNameStaticGetRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelCityNameHotelNameStaticGet(
    requestParameters: HotelApiApiHotelCityNameHotelNameStaticGetRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelCityNameHotelNameStaticGetAxiosParamCreator(
            requestParameters.cityName,
            requestParameters.hotelName,
            options,
            configuration
        );
    const request: () => AxiosPromise<HotelResponse> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @summary Get City List (only PersianName)
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelCityNameListGet(
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelCityNameListGetAxiosParamCreator(
            options,
            configuration
        );
    const request: () => AxiosPromise<Array<HotelCityNameDto>> =
        createRequestFunction(
            localVarAxiosArgs,
            globalAxios,
            BASE_PATH,
            configuration
        );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelCityTagGetRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelCityTagGet(
    requestParameters: HotelApiApiHotelCityTagGetRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs = await HotelApiApiHotelCityTagGetAxiosParamCreator(
        requestParameters.cityTag,
        options,
        configuration
    );
    const request: () => AxiosPromise<HotelSearchResponse> =
        createRequestFunction(
            localVarAxiosArgs,
            globalAxios,
            BASE_PATH,
            configuration
        );
    return request();
}
/**
 *
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelCommentCaptchaGet(
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelCommentCaptchaGetAxiosParamCreator(
            options,
            configuration
        );
    const request: () => AxiosPromise<DNTCaptchaApiResponse> =
        createRequestFunction(
            localVarAxiosArgs,
            globalAxios,
            BASE_PATH,
            configuration
        );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelCreateHotelMappingHotelIdPostRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelCreateHotelMappingHotelIdPost(
    requestParameters: HotelApiApiHotelCreateHotelMappingHotelIdPostRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelCreateHotelMappingHotelIdPostAxiosParamCreator(
            requestParameters.hotelId,
            requestParameters.addHotelMappingRequest,
            options,
            configuration
        );
    const request: () => AxiosPromise<void> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @summary Delete Hotel Block with its Details
 * @param {HotelApiApiHotelDeleteHotelBlockDeleteRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelDeleteHotelBlockDelete(
    requestParameters: HotelApiApiHotelDeleteHotelBlockDeleteRequest = {},
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelDeleteHotelBlockDeleteAxiosParamCreator(
            requestParameters.blockId,
            options,
            configuration
        );
    const request: () => AxiosPromise<void> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelDeleteHotelMappingHotelIdHotelMappingIdDeleteRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelDeleteHotelMappingHotelIdHotelMappingIdDelete(
    requestParameters: HotelApiApiHotelDeleteHotelMappingHotelIdHotelMappingIdDeleteRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelDeleteHotelMappingHotelIdHotelMappingIdDeleteAxiosParamCreator(
            requestParameters.hotelId,
            requestParameters.hotelMappingId,
            options,
            configuration
        );
    const request: () => AxiosPromise<void> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @summary Delete Hotel Markup with its constraints
 * @param {HotelApiApiHotelDeleteHotelMarkupDeleteRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelDeleteHotelMarkupDelete(
    requestParameters: HotelApiApiHotelDeleteHotelMarkupDeleteRequest = {},
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelDeleteHotelMarkupDeleteAxiosParamCreator(
            requestParameters.markupId,
            options,
            configuration
        );
    const request: () => AxiosPromise<void> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @summary Delete Special Offer with its items
 * @param {HotelApiApiHotelDeleteSpecialOfferDeleteRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelDeleteSpecialOfferDelete(
    requestParameters: HotelApiApiHotelDeleteSpecialOfferDeleteRequest = {},
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelDeleteSpecialOfferDeleteAxiosParamCreator(
            requestParameters.specialOfferId,
            options,
            configuration
        );
    const request: () => AxiosPromise<void> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelGetAllHotelsGet(
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelGetAllHotelsGetAxiosParamCreator(
            options,
            configuration
        );
    const request: () => AxiosPromise<Array<HotelDto>> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelGetHotelsWithRoomsCityIdGetRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelGetHotelsWithRoomsCityIdGet(
    requestParameters: HotelApiApiHotelGetHotelsWithRoomsCityIdGetRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelGetHotelsWithRoomsCityIdGetAxiosParamCreator(
            requestParameters.cityId,
            requestParameters.from,
            requestParameters.to,
            requestParameters.isOnlyDb,
            options,
            configuration
        );
    const request: () => AxiosPromise<HotelCityFullDetailView> =
        createRequestFunction(
            localVarAxiosArgs,
            globalAxios,
            BASE_PATH,
            configuration
        );
    return request();
}
/**
 *
 * @summary Get Hotel AutoComplete List
 * @param {HotelApiApiHotelHotelAutoCompleteListGetRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelHotelAutoCompleteListGet(
    requestParameters: HotelApiApiHotelHotelAutoCompleteListGetRequest = {},
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelHotelAutoCompleteListGetAxiosParamCreator(
            requestParameters.searchTerm,
            options,
            configuration
        );
    const request: () => AxiosPromise<AutoCompleteHotelResponse> =
        createRequestFunction(
            localVarAxiosArgs,
            globalAxios,
            BASE_PATH,
            configuration
        );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelHotelAvailabilityCityNameHotelNameGetRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelHotelAvailabilityCityNameHotelNameGet(
    requestParameters: HotelApiApiHotelHotelAvailabilityCityNameHotelNameGetRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelHotelAvailabilityCityNameHotelNameGetAxiosParamCreator(
            requestParameters.cityName,
            requestParameters.hotelName,
            requestParameters.from,
            requestParameters.to,
            options,
            configuration
        );
    const request: () => AxiosPromise<string> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @summary Get Hotel Block Detail
 * @param {HotelApiApiHotelHotelBlockDetailGetRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelHotelBlockDetailGet(
    requestParameters: HotelApiApiHotelHotelBlockDetailGetRequest = {},
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelHotelBlockDetailGetAxiosParamCreator(
            requestParameters.cityName,
            options,
            configuration
        );
    const request: () => AxiosPromise<Array<GetHotelBlockDetailsResponse>> =
        createRequestFunction(
            localVarAxiosArgs,
            globalAxios,
            BASE_PATH,
            configuration
        );
    return request();
}
/**
 *
 * @summary Get Hotel Block List
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelHotelBlockListGet(
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelHotelBlockListGetAxiosParamCreator(
            options,
            configuration
        );
    const request: () => AxiosPromise<Array<GetHotelBlockListResponse>> =
        createRequestFunction(
            localVarAxiosArgs,
            globalAxios,
            BASE_PATH,
            configuration
        );
    return request();
}
/**
 *
 * @summary Get Hotel Block Detail to preview
 * @param {HotelApiApiHotelHotelBlocksGetRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelHotelBlocksGet(
    requestParameters: HotelApiApiHotelHotelBlocksGetRequest = {},
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelHotelBlocksGetAxiosParamCreator(
            requestParameters.blockId,
            options,
            configuration
        );
    const request: () => AxiosPromise<HotelBlockResponse> =
        createRequestFunction(
            localVarAxiosArgs,
            globalAxios,
            BASE_PATH,
            configuration
        );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelHotelCommentCommentIdDeleteRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelHotelCommentCommentIdDelete(
    requestParameters: HotelApiApiHotelHotelCommentCommentIdDeleteRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelHotelCommentCommentIdDeleteAxiosParamCreator(
            requestParameters.commentId,
            options,
            configuration
        );
    const request: () => AxiosPromise<void> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelHotelCommentDetailHotelCommentIdGetRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelHotelCommentDetailHotelCommentIdGet(
    requestParameters: HotelApiApiHotelHotelCommentDetailHotelCommentIdGetRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelHotelCommentDetailHotelCommentIdGetAxiosParamCreator(
            requestParameters.hotelCommentId,
            options,
            configuration
        );
    const request: () => AxiosPromise<GetHotelCommentDetailResponse> =
        createRequestFunction(
            localVarAxiosArgs,
            globalAxios,
            BASE_PATH,
            configuration
        );
    return request();
}
/**
 *
 * @summary Get Hotel comment List
 * @param {HotelApiApiHotelHotelCommentListHotelIdGetRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelHotelCommentListHotelIdGet(
    requestParameters: HotelApiApiHotelHotelCommentListHotelIdGetRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelHotelCommentListHotelIdGetAxiosParamCreator(
            requestParameters.hotelId,
            requestParameters.pageIndex,
            requestParameters.pageSize,
            requestParameters.isActive,
            options,
            configuration
        );
    const request: () => AxiosPromise<GetHotelCommentListResponse> =
        createRequestFunction(
            localVarAxiosArgs,
            globalAxios,
            BASE_PATH,
            configuration
        );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelHotelCommentPostRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelHotelCommentPost(
    requestParameters: HotelApiApiHotelHotelCommentPostRequest = {},
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelHotelCommentPostAxiosParamCreator(
            requestParameters.createHotelCommentRequest,
            options,
            configuration
        );
    const request: () => AxiosPromise<GetHotelCommentDetailResponse> =
        createRequestFunction(
            localVarAxiosArgs,
            globalAxios,
            BASE_PATH,
            configuration
        );
    return request();
}
/**
 *
 * @summary Get Hotel Full Details
 * @param {HotelApiApiHotelHotelFullDetailsHotelIdGetRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelHotelFullDetailsHotelIdGet(
    requestParameters: HotelApiApiHotelHotelFullDetailsHotelIdGetRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelHotelFullDetailsHotelIdGetAxiosParamCreator(
            requestParameters.hotelId,
            options,
            configuration
        );
    const request: () => AxiosPromise<HotelFullDetailsResponse> =
        createRequestFunction(
            localVarAxiosArgs,
            globalAxios,
            BASE_PATH,
            configuration
        );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelHotelIdAddCommentPostRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelHotelIdAddCommentPost(
    requestParameters: HotelApiApiHotelHotelIdAddCommentPostRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelHotelIdAddCommentPostAxiosParamCreator(
            requestParameters.hotelId,
            requestParameters.body,
            requestParameters.reserved,
            requestParameters.commentRatings,
            requestParameters.photos,
            requestParameters.dNTCaptchaText,
            requestParameters.dNTCaptchaInputText,
            requestParameters.dNTCaptchaToken,
            options,
            configuration
        );
    const request: () => AxiosPromise<void> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelHotelIdAddHotelRoomTypePostRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelHotelIdAddHotelRoomTypePost(
    requestParameters: HotelApiApiHotelHotelIdAddHotelRoomTypePostRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelHotelIdAddHotelRoomTypePostAxiosParamCreator(
            requestParameters.hotelId,
            requestParameters.addHotelRoomTypeRequest,
            options,
            configuration
        );
    const request: () => AxiosPromise<void> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelHotelIdAllRoomsGetRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelHotelIdAllRoomsGet(
    requestParameters: HotelApiApiHotelHotelIdAllRoomsGetRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelHotelIdAllRoomsGetAxiosParamCreator(
            requestParameters.hotelId,
            options,
            configuration
        );
    const request: () => AxiosPromise<Array<HotelRoomTypeView>> =
        createRequestFunction(
            localVarAxiosArgs,
            globalAxios,
            BASE_PATH,
            configuration
        );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelHotelIdAssignMappingMappingIdPostRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelHotelIdAssignMappingMappingIdPost(
    requestParameters: HotelApiApiHotelHotelIdAssignMappingMappingIdPostRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelHotelIdAssignMappingMappingIdPostAxiosParamCreator(
            requestParameters.hotelId,
            requestParameters.mappingId,
            options,
            configuration
        );
    const request: () => AxiosPromise<void> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelHotelIdGetRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelHotelIdGet(
    requestParameters: HotelApiApiHotelHotelIdGetRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs = await HotelApiApiHotelHotelIdGetAxiosParamCreator(
        requestParameters.hotelId,
        requestParameters.from,
        requestParameters.to,
        requestParameters.adultCount,
        requestParameters.childrenCount,
        requestParameters.roomCount,
        options,
        configuration
    );
    const request: () => AxiosPromise<HotelResponse> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelHotelIdGetHotelAmenitiesGetRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelHotelIdGetHotelAmenitiesGet(
    requestParameters: HotelApiApiHotelHotelIdGetHotelAmenitiesGetRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelHotelIdGetHotelAmenitiesGetAxiosParamCreator(
            requestParameters.hotelId,
            options,
            configuration
        );
    const request: () => AxiosPromise<Array<GetHotelAmenitiesResponse>> =
        createRequestFunction(
            localVarAxiosArgs,
            globalAxios,
            BASE_PATH,
            configuration
        );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelHotelIdPopularPlacesGetRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelHotelIdPopularPlacesGet(
    requestParameters: HotelApiApiHotelHotelIdPopularPlacesGetRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelHotelIdPopularPlacesGetAxiosParamCreator(
            requestParameters.hotelId,
            options,
            configuration
        );
    const request: () => AxiosPromise<Array<GetHotelPopularPlaceResponse>> =
        createRequestFunction(
            localVarAxiosArgs,
            globalAxios,
            BASE_PATH,
            configuration
        );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelHotelIdPopularPlacesPopularPlaceIdDeleteRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelHotelIdPopularPlacesPopularPlaceIdDelete(
    requestParameters: HotelApiApiHotelHotelIdPopularPlacesPopularPlaceIdDeleteRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelHotelIdPopularPlacesPopularPlaceIdDeleteAxiosParamCreator(
            requestParameters.hotelId,
            requestParameters.popularPlaceId,
            options,
            configuration
        );
    const request: () => AxiosPromise<void> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelHotelIdPopularPlacesPostRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelHotelIdPopularPlacesPost(
    requestParameters: HotelApiApiHotelHotelIdPopularPlacesPostRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelHotelIdPopularPlacesPostAxiosParamCreator(
            requestParameters.hotelId,
            requestParameters.addHotelPopularPlaceRequest,
            options,
            configuration
        );
    const request: () => AxiosPromise<GetHotelPopularPlaceResponse> =
        createRequestFunction(
            localVarAxiosArgs,
            globalAxios,
            BASE_PATH,
            configuration
        );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelHotelIdPopularPlacesPutRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelHotelIdPopularPlacesPut(
    requestParameters: HotelApiApiHotelHotelIdPopularPlacesPutRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelHotelIdPopularPlacesPutAxiosParamCreator(
            requestParameters.hotelId,
            requestParameters.addHotelPopularPlaceRequest,
            options,
            configuration
        );
    const request: () => AxiosPromise<void> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelHotelIdRoomtypesUnusedDeleteRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelHotelIdRoomtypesUnusedDelete(
    requestParameters: HotelApiApiHotelHotelIdRoomtypesUnusedDeleteRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelHotelIdRoomtypesUnusedDeleteAxiosParamCreator(
            requestParameters.hotelId,
            options,
            configuration
        );
    const request: () => AxiosPromise<void> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelHotelIdStaticGetRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelHotelIdStaticGet(
    requestParameters: HotelApiApiHotelHotelIdStaticGetRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelHotelIdStaticGetAxiosParamCreator(
            requestParameters.hotelId,
            options,
            configuration
        );
    const request: () => AxiosPromise<HotelResponse> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelHotelIdTagGetRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelHotelIdTagGet(
    requestParameters: HotelApiApiHotelHotelIdTagGetRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelHotelIdTagGetAxiosParamCreator(
            requestParameters.hotelId,
            options,
            configuration
        );
    const request: () => AxiosPromise<Array<GetHotelPopularPlaceResponse>> =
        createRequestFunction(
            localVarAxiosArgs,
            globalAxios,
            BASE_PATH,
            configuration
        );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelHotelIdToggleHotelRoomTypePutRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelHotelIdToggleHotelRoomTypePut(
    requestParameters: HotelApiApiHotelHotelIdToggleHotelRoomTypePutRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelHotelIdToggleHotelRoomTypePutAxiosParamCreator(
            requestParameters.hotelId,
            requestParameters.roomTypeId,
            options,
            configuration
        );
    const request: () => AxiosPromise<void> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelHotelIdUpdateHotelRoomTypePostRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelHotelIdUpdateHotelRoomTypePost(
    requestParameters: HotelApiApiHotelHotelIdUpdateHotelRoomTypePostRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelHotelIdUpdateHotelRoomTypePostAxiosParamCreator(
            requestParameters.hotelId,
            requestParameters.updateHotelRoomTypeRequest,
            options,
            configuration
        );
    const request: () => AxiosPromise<void> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelHotelMappingListHotelIdGetRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelHotelMappingListHotelIdGet(
    requestParameters: HotelApiApiHotelHotelMappingListHotelIdGetRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelHotelMappingListHotelIdGetAxiosParamCreator(
            requestParameters.hotelId,
            options,
            configuration
        );
    const request: () => AxiosPromise<GetHotelMappingListResponse> =
        createRequestFunction(
            localVarAxiosArgs,
            globalAxios,
            BASE_PATH,
            configuration
        );
    return request();
}
/**
 *
 * @summary Get Hotel Markup Detail
 * @param {HotelApiApiHotelHotelMarkupDetailGetRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelHotelMarkupDetailGet(
    requestParameters: HotelApiApiHotelHotelMarkupDetailGetRequest = {},
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelHotelMarkupDetailGetAxiosParamCreator(
            requestParameters.idMarkup,
            options,
            configuration
        );
    const request: () => AxiosPromise<GetHotelMarkupDetailDto> =
        createRequestFunction(
            localVarAxiosArgs,
            globalAxios,
            BASE_PATH,
            configuration
        );
    return request();
}
/**
 *
 * @summary Get Hotel Markup List
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelHotelMarkupListGet(
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelHotelMarkupListGetAxiosParamCreator(
            options,
            configuration
        );
    const request: () => AxiosPromise<Array<GetHotelMarkupResponse>> =
        createRequestFunction(
            localVarAxiosArgs,
            globalAxios,
            BASE_PATH,
            configuration
        );
    return request();
}
/**
 *
 * @summary Get Hotel Type List
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelHotelTypeListGet(
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelHotelTypeListGetAxiosParamCreator(
            options,
            configuration
        );
    const request: () => AxiosPromise<HotelTypeListResponse> =
        createRequestFunction(
            localVarAxiosArgs,
            globalAxios,
            BASE_PATH,
            configuration
        );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelHotelsAvailabilityByCityCityCodeGetRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelHotelsAvailabilityByCityCityCodeGet(
    requestParameters: HotelApiApiHotelHotelsAvailabilityByCityCityCodeGetRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelHotelsAvailabilityByCityCityCodeGetAxiosParamCreator(
            requestParameters.cityCode,
            requestParameters.from,
            requestParameters.to,
            options,
            configuration
        );
    const request: () => AxiosPromise<string> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelHotelsWithMessageGet(
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelHotelsWithMessageGetAxiosParamCreator(
            options,
            configuration
        );
    const request: () => AxiosPromise<Array<HotelFullDetailView>> =
        createRequestFunction(
            localVarAxiosArgs,
            globalAxios,
            BASE_PATH,
            configuration
        );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelLatitudeLongitudeNearByCitiesGetRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelLatitudeLongitudeNearByCitiesGet(
    requestParameters: HotelApiApiHotelLatitudeLongitudeNearByCitiesGetRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelLatitudeLongitudeNearByCitiesGetAxiosParamCreator(
            requestParameters.latitude,
            requestParameters.longitude,
            options,
            configuration
        );
    const request: () => AxiosPromise<HotelNearByCitiesResponse> =
        createRequestFunction(
            localVarAxiosArgs,
            globalAxios,
            BASE_PATH,
            configuration
        );
    return request();
}
/**
 *
 * @summary update message of hotel
 * @param {HotelApiApiHotelMessagePostRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelMessagePost(
    requestParameters: HotelApiApiHotelMessagePostRequest = {},
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelMessagePostAxiosParamCreator(
            requestParameters.editHotelMessageRequest,
            options,
            configuration
        );
    const request: () => AxiosPromise<void> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelOrphanHotelMappingsGet(
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelOrphanHotelMappingsGetAxiosParamCreator(
            options,
            configuration
        );
    const request: () => AxiosPromise<OphanHotelMappingsResponse> =
        createRequestFunction(
            localVarAxiosArgs,
            globalAxios,
            BASE_PATH,
            configuration
        );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelPostRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelPost(
    requestParameters: HotelApiApiHotelPostRequest = {},
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs = await HotelApiApiHotelPostAxiosParamCreator(
        requestParameters.createHotelRequest,
        options,
        configuration
    );
    const request: () => AxiosPromise<CreateHotelResponse> =
        createRequestFunction(
            localVarAxiosArgs,
            globalAxios,
            BASE_PATH,
            configuration
        );
    return request();
}
/**
 *
 * @summary this method remove hotel page cache by hotel id
 * @param {HotelApiApiHotelRemoveHotelPageCacheHotelIdDeleteRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelRemoveHotelPageCacheHotelIdDelete(
    requestParameters: HotelApiApiHotelRemoveHotelPageCacheHotelIdDeleteRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelRemoveHotelPageCacheHotelIdDeleteAxiosParamCreator(
            requestParameters.hotelId,
            options,
            configuration
        );
    const request: () => AxiosPromise<boolean> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @summary Sort Hotel Markups by Priority
 * @param {HotelApiApiHotelSortHotelMarkupPostRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelSortHotelMarkupPost(
    requestParameters: HotelApiApiHotelSortHotelMarkupPostRequest = {},
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelSortHotelMarkupPostAxiosParamCreator(
            requestParameters.sortHotelMarkupRequest,
            options,
            configuration
        );
    const request: () => AxiosPromise<void> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @summary Get Hotel Special Offer List
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelSpecialOfferListGet(
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelSpecialOfferListGetAxiosParamCreator(
            options,
            configuration
        );
    const request: () => AxiosPromise<Array<GetHotelSpecialOffersResponse>> =
        createRequestFunction(
            localVarAxiosArgs,
            globalAxios,
            BASE_PATH,
            configuration
        );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelTagPostRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelTagPost(
    requestParameters: HotelApiApiHotelTagPostRequest = {},
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs = await HotelApiApiHotelTagPostAxiosParamCreator(
        requestParameters.createHotelTagRequest,
        options,
        configuration
    );
    const request: () => AxiosPromise<GetHotelPopularPlaceResponse> =
        createRequestFunction(
            localVarAxiosArgs,
            globalAxios,
            BASE_PATH,
            configuration
        );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelTagTagIdDeleteRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelTagTagIdDelete(
    requestParameters: HotelApiApiHotelTagTagIdDeleteRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelTagTagIdDeleteAxiosParamCreator(
            requestParameters.tagId,
            options,
            configuration
        );
    const request: () => AxiosPromise<void> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelToggleHotelCommentHotelIdHotelCommentIdIsActivePostRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelToggleHotelCommentHotelIdHotelCommentIdIsActivePost(
    requestParameters: HotelApiApiHotelToggleHotelCommentHotelIdHotelCommentIdIsActivePostRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelToggleHotelCommentHotelIdHotelCommentIdIsActivePostAxiosParamCreator(
            requestParameters.hotelId,
            requestParameters.hotelCommentId,
            requestParameters.isActive,
            options,
            configuration
        );
    const request: () => AxiosPromise<void> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelToggleHotelMappingHotelIdHotelMappingIdPostRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelToggleHotelMappingHotelIdHotelMappingIdPost(
    requestParameters: HotelApiApiHotelToggleHotelMappingHotelIdHotelMappingIdPostRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelToggleHotelMappingHotelIdHotelMappingIdPostAxiosParamCreator(
            requestParameters.hotelId,
            requestParameters.hotelMappingId,
            options,
            configuration
        );
    const request: () => AxiosPromise<void> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelToggleHotelMappingSaleEnableHotelMappingIdSaleEnablePostRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelToggleHotelMappingSaleEnableHotelMappingIdSaleEnablePost(
    requestParameters: HotelApiApiHotelToggleHotelMappingSaleEnableHotelMappingIdSaleEnablePostRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelToggleHotelMappingSaleEnableHotelMappingIdSaleEnablePostAxiosParamCreator(
            requestParameters.hotelMappingId,
            requestParameters.saleEnable,
            options,
            configuration
        );
    const request: () => AxiosPromise<boolean> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelUpdateAmenityPutRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelUpdateAmenityPut(
    requestParameters: HotelApiApiHotelUpdateAmenityPutRequest = {},
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelUpdateAmenityPutAxiosParamCreator(
            requestParameters.updateAmenityRequest,
            options,
            configuration
        );
    const request: () => AxiosPromise<void> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelUpdateHotelAmenitiesHotelIdPostRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelUpdateHotelAmenitiesHotelIdPost(
    requestParameters: HotelApiApiHotelUpdateHotelAmenitiesHotelIdPostRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelUpdateHotelAmenitiesHotelIdPostAxiosParamCreator(
            requestParameters.hotelId,
            requestParameters.addHotelAmenitiesRequest,
            options,
            configuration
        );
    const request: () => AxiosPromise<void> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @summary Update Hotel Hotel Block with details
 * @param {HotelApiApiHotelUpdateHotelBlockPostRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelUpdateHotelBlockPost(
    requestParameters: HotelApiApiHotelUpdateHotelBlockPostRequest = {},
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelUpdateHotelBlockPostAxiosParamCreator(
            requestParameters.updateHotelBlockRequest,
            options,
            configuration
        );
    const request: () => AxiosPromise<void> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelUpdateHotelCommentHotelIdPostRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelUpdateHotelCommentHotelIdPost(
    requestParameters: HotelApiApiHotelUpdateHotelCommentHotelIdPostRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelUpdateHotelCommentHotelIdPostAxiosParamCreator(
            requestParameters.hotelId,
            requestParameters.updateHotelCommentRequest,
            options,
            configuration
        );
    const request: () => AxiosPromise<void> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelUpdateHotelImageFromProviderPostRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelUpdateHotelImageFromProviderPost(
    requestParameters: HotelApiApiHotelUpdateHotelImageFromProviderPostRequest = {},
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelUpdateHotelImageFromProviderPostAxiosParamCreator(
            requestParameters.updateHotelImageRequest,
            options,
            configuration
        );
    const request: () => AxiosPromise<void> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelUpdateHotelMappingHotelIdPostRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelUpdateHotelMappingHotelIdPost(
    requestParameters: HotelApiApiHotelUpdateHotelMappingHotelIdPostRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelUpdateHotelMappingHotelIdPostAxiosParamCreator(
            requestParameters.hotelId,
            requestParameters.updateHotelMappingRequest,
            options,
            configuration
        );
    const request: () => AxiosPromise<void> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @summary Update Hotel Markup with its constraints
 * @param {HotelApiApiHotelUpdateHotelMarkupPostRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelUpdateHotelMarkupPost(
    requestParameters: HotelApiApiHotelUpdateHotelMarkupPostRequest = {},
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelUpdateHotelMarkupPostAxiosParamCreator(
            requestParameters.updateHotelMarkupDto,
            options,
            configuration
        );
    const request: () => AxiosPromise<void> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelUpdateHotelPostRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelUpdateHotelPost(
    requestParameters: HotelApiApiHotelUpdateHotelPostRequest = {},
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelUpdateHotelPostAxiosParamCreator(
            requestParameters.updateHotelRequest,
            options,
            configuration
        );
    const request: () => AxiosPromise<void> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @param {HotelApiApiHotelUpdateHotelRoomTypeMappingHotelIdPostRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelUpdateHotelRoomTypeMappingHotelIdPost(
    requestParameters: HotelApiApiHotelUpdateHotelRoomTypeMappingHotelIdPostRequest,
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelUpdateHotelRoomTypeMappingHotelIdPostAxiosParamCreator(
            requestParameters.hotelId,
            requestParameters.updateHotelRoomTypeMappingRequest,
            options,
            configuration
        );
    const request: () => AxiosPromise<void> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @summary update Special Offer with its items
 * @param {HotelApiApiHotelUpdateSpecialOfferPostRequest} requestParameters Request parameters.
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelUpdateSpecialOfferPost(
    requestParameters: HotelApiApiHotelUpdateSpecialOfferPostRequest = {},
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelUpdateSpecialOfferPostAxiosParamCreator(
            requestParameters.updateHotelSpecialOfferRequest,
            options,
            configuration
        );
    const request: () => AxiosPromise<void> = createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
    );
    return request();
}
/**
 *
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function HotelApiApiHotelVisibleHotelBlockListGet(
    options?: AxiosRequestConfig,
    configuration?: Configuration
) {
    const localVarAxiosArgs =
        await HotelApiApiHotelVisibleHotelBlockListGetAxiosParamCreator(
            options,
            configuration
        );
    const request: () => AxiosPromise<GetVisibleHotelBlockResponse> =
        createRequestFunction(
            localVarAxiosArgs,
            globalAxios,
            BASE_PATH,
            configuration
        );
    return request();
}
